import i18n, { use } from "i18next";
import { initReactI18next } from "react-i18next";

import { convertToEasternArabic } from "utils";

import { blogPosts } from "pages/Landing/siteBlogs/BlogData";

// import { meeting } from "assets/images/landing/meeting.png";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)

const resources = {
  en: {
    translation: {
      all: "All",
      noDataFound: "No Data Found",
      addReasonHere: "Add Reason Here",
      rejectMeeting: "Reject Meeting",
      calendarHomeText:
        "Check everything on this page your upcoming, recent and past meetings with details",
      expend: "Expend",
      meetingRecords: "Meeting Records",
      name: "Name",
      meetingExpired: "Meeting duration has expired.",
      passwordReset: "Password Reset",
      weSentCode: "we sent code to",
      didntReceiveEmail: "Didn't receive the email?",
      clickResend: "Click to resend",
      viewAgenda: "View Agenda",
      createdBy: "Created By",
      profileUpdated: "Profile Updated",
      continue: "Continue",
      and: "and",
      sliderTitle1:
        "Transform your meetings into a smarter, more organized experience with Mahdar",
      sliderDes1:
        "A comprehensive meeting management platform that offers advanced collaboration tools, AI-powered smart summaries, and accurate recordings — helping you stay focused and make better decisions.",
      free: "Free",
      basic: "Basic",
      businessStarter: "Business Starter",
      businessStandard: "Business Standard",
      businessPlus: "Business Plus",
      trialAlreadyUsed: "Trial already used",
      export: "Export",
      deleteWorkspace: "Delete Workspace",
      updatePassword: "Update password",
      noAgendaFound: "No Agenda found",
      pleaseAddMeetingUrl: "Please enter a valid URL",
      enterOtp: "Please enter OTP",
      yourScheduledMeetings: "Your Scheduled Meetings",
      startTrial: "Start Meeting",
      enjoyExtendedMeetingDurations:
        "Enjoy extended meeting durations, advanced collaboration tools, and AI-powered meeting summaries with a 1-month free trial of Nassar One Premium.",
      unlockPremiumNassarMeetFeatures: "Unlock Premium Nassar Meet Features",
      pasteMeetingUrl: "Paste your meeting url here",
      instantlyConnectWithYourTeam:
        "Join your meeting instantly with Mahdar — no downloads, no delays, just seamless communication.",
      seamlessVideoCallsMeetingsForEveryone:
        "Effortless video conferencing experiences for all.",
      meetingCreatedSuccessfully: "Meeting Created Successfully",
      fillPreviousAgenda: "Please fill the previous agenda first.",
      areYouSure: "Are you sure you want to deactivate",
      loginWith: "Log In with",
      rememberMe: "Remember me",
      register: "Register",
      allDepartments: "All Departments",
      haveAccount: "Don't have an account?",
      viewMore: "View More",
      view: "View",
      allNotif: "All",
      unread: "Unread",
      hostedBy: "Hosted By",
      upComingMeeting: "Upcoming Meetings",
      invitetoSignMeetingSummary: "Invite to Sign Meeting Summary",
      views: {
        month: "Month",
        week: "Week",
        work_week: "Work Week",
        day: "Day",
        agenda: "Agenda",
      },
      landingPage: {
        minutes: "Minutes",
        partners: "Potential Partners",
        navbar: {
          getStarted: "Get Started",
          login: "Login",
          contact: "Contact",
          whyUs: "About Us",
          blogs: "Blogs",
          pricingPlans: "Plans",
          home: "Home",
          community: "Community",
        },
        footer: {
          whyChooseUs: "About Us",
          termsConditions: "Terms & Conditions",
          privacyPolicy: "Privacy Policy",
        },
        home: {
          tryBasic: "Try Our Basic Package",
          instantMeetHeader:
            "An integrated online meeting platform that starts and ends the meeting with an approved minutes document",
          instantMeetDes:
            "Manage board, committee, and executive team meetings in a single platform that combines recording, AI transcription, minutes drafting, electronic approval, and task execution tracking.",
          startInstantMeet: "Start your free trial now",
          meetingUrlPlaceholder: "Paste your meeting url here",
          reviewsNumber: "Based on 10,000+ reviews",
          smartSol:
            "Manage your meetings from one place, from planning to approved minutes",
          smartSolDes: "Why do you need Mahdar?",
          summary: "Summary",
          sumTitle: "Transforming discussions into professional minutes",
          summaryDes:
            "Invest in your team's efficiency: Our AI-driven system automatically provides you with structured, professional meeting summaries. Core decisions and assigned tasks are documented with high accuracy to ensure effective follow-up and goal achievement.",
          seeFullSummary: "See Full Summary",
          agenda: "Agenda",
          agendaManag: "Electronic Approval of Minutes",
          agendaDes:
            "Approve minutes quickly and securely from all parties via Signit for electronic signatures, without the need for printing or exchanging paper copies, while storing all versions in one place.",
          seeFullAgenda:
            "See how your agenda turns into approved minutes within minutes",
          recording: "Artificial Intelligence",
          recordingTitle: "Archiving All Minutes",
          recordingAiDes:
            "Keep all your meeting minutes in one place, with easy and secure access and search capability at any time.",
          aboutMahadar: "All About Mahdar",
          aboutMahadarTitle: "What is Mahdar?",
          aboutMahadarDes:
            "Mahdar is the document created after each meeting to record everything that occurred with accuracy and professionalism. It helps maintain organized workflows, ensures decision and task follow-ups, and reflects a professional image of your team or organization.",
          aboutMahadarDes1:
            "Mahdar helps you maintain organized work, ensure decision and task follow-ups, and reflects a professional image of your team or organization.",
          aboutMahadarDes2: "Meeting Minutes include:",
          aboutMahadarDes3:
            "Meeting details (Title, Date, Time, Organizers, Attendees)",
          aboutMahadarDes4: "Agenda and topics discussed",
          aboutMahadarDes5: "Final decisions and assignments",
          aboutMahadarDes6: "Approval and sign-off signatures",
          aboutMahadarDes7:
            "Ability to attach supporting documents and attachments",
          aboutMahadarLink: "Download Demo Summary Page",
          signTitle: "E-Signature",
          signDes1: "Approve meeting minutes officially, easily, and securely.",
          signDes:
            "Sign meeting minutes electronically using a seamless and reliable interface. Streamline approval and follow-up processes, saving time through instant signatures without printing or scanning. The system supports signature tracking and confirmation to ensure full compliance and transparency.",
          seePastSign:
            "A fully integrated and secure digital signing experience",
          recordingDes:
            "Transforms meetings into structured, clear minutes within minutes using AI, professionally documenting action plans and key points ready for sharing.",
          seePastRecording:
            "Meeting → Minutes → Signature → Execution. Everything within one platform.",
          howItWorks: "How it works?",
          oneClickMeet:
            "For an instant, documented meeting: start your free trial with a single click",
          meetInstantly: "Create the Meeting",
          meetInstantlyDes:
            "Create a meeting in seconds, send the link, and let the platform automatically capture discussions and turn them into minutes ready for signing.",
          meetStartInstant: "Start an Instant Meeting",

          collab: "Record the Meeting",
          collabDes:
            "Record the meeting via audio or video, whether in-person or remote, to accurately document all interventions and discussions without the need for manual note-taking.",
          scheduleMeeting: "Schedule a Meeting",
          aiGenTitle: "Automatic Minutes Generation",
          aiGenDes:
            "AI converts the meeting recording into professional minutes including attendees, agenda, recommendations, and action plans in clear phrasing ready for review and sharing.",
          viewDemoSummary: "View Demo Summary",

          chooseBestPlan: "Approval of Minutes",
          choosePlanDes:
            "Review and officially approve minutes electronically via Signit, enabling fast and secure signing by all parties with all versions stored in one place—no printing or paper exchange needed.",
          pricingPlans: "Pricing Plans",
          testimonials: "Testimonials",
          whyUseMehdar:
            "Discover why professionals prefer Mahdar for unparalleled meeting productivity",
          mahdar: "Mahdar",
          mahdarDes: `It completely changed the way we handle meetings. The AI-generated summaries save us hours of manual note-taking, and we never miss any important decisions!`,
          ahmedR: "Ahmed R. – Project Manager",
          review2: "Managing my team's remote meetings has never been easier.",
          review2End: `Thanks to automated transcription and action item tracking, we stay organized and productive effortlessly.`,
          saraL: "Sarah L. – CEO at TechFlow",
          iLoveHow: "I love how it",
          review3: `simplifies meeting documentation. We use it for interviews and group discussions, and AI-powered summaries ensure every important detail is captured effortlessly.`,
          davidM: "David M. – HR Director",
          ourSocials: "Our Social Media",
          footerDes: `Mahdar is an all-in-one online meeting platform that allows you to create and host virtual meetings, generating a digital meeting minutes document ready right after finishing.`,
          footerDes1: `Mahdar unifies everything related to meetings into a single workflow without needing multiple tools; analyzing discussions, converting speech to text automatically, and linking discussed points to agenda items to produce accurate, organized minutes.`,
          footerDes2: `It also enables official minutes approval via e-signature, saving and sharing them as a clear reference accessible anytime within a secure, user-friendly environment.`,
          footerDes3:
            "Mahdar is not just a recording tool, but a complete operational platform converting meetings from video calls into actionable outputs.",
          product: "Platform Guide",
          ourOtherPlatforms: "Our Other Platforms",
          facebook: "Facebook",
          linkedIn: "LinkedIn",
          x: "X",
          youtube: "YouTube",
          instagram: "Instagram",
          aboutWorkspaces: "All About Workspaces",
          whatWorkspace: "What is a Workspace?",
          whatWorkspaceDes1:
            "A workspace is an organizational unit that brings team members together in one place to manage meetings, track tasks, and document work within a specific department or project.",
          whatWorkspaceDes2: `A "Workspace" helps streamline collaboration, clarify roles, and boost team productivity.`,
          workspaceLink: `A fully organized and collaborative workspace experience`,
          workspaceListingTitle: "A Workspace allows you to:",
          workspaceListing1:
            "Create separate departments and teams within the platform",
          workspaceListing2: "Add members and monitor their activity",
          workspaceListing3: "Schedule meetings and document their minutes",
          workspaceListing4:
            "Organize files and tasks in one centralized place",
          workspaceListing5:
            "Customize descriptions and set a specific time frame for each workspace",
        },
        pricingPlans: {
          choosePlan: "Choose the right plan for your business.",
          rightPlanDes: `Whether you manage a small team, a board of directors, or a large organization, Mahdar offers flexible plans tailored to your needs, with the option to upgrade at any time.`,
          monthly: "monthly",
          permissionPer: "You Have 50% Permission",
          mostPopular: "Most Popular",
        },
        whyUs: {
          whyChooseUs: "Why Choose Mahdar?",
          whyChooseUsDes:
            "Because Mahdar provides more than just a meeting recording tool; it offers a smart, integrated documentation system that aligns with the needs of individuals, teams, and official entities.",

          smart: "Save Your Team's Time",
          smartDes:
            "Cut down the time spent taking meeting notes and preparing minutes. Let AI convert discussions into professional minutes within minutes, enabling your team to focus on work rather than administrative tasks.",

          instant: "Elevate Governance Quality",
          instantDes:
            "Ensure meetings, action plans, and recommendations are documented using a unified, professional framework, boosting transparency and supporting best governance practices within your organization.",

          getStarted: "Enhance Accountability",
          getStartedDes:
            "Turn meeting outputs into clear action plans assigned to responsible owners, fully documented and archived, making execution follow-up easier and clarifying responsibilities among team members.",

          getStarted2: "Simple User Experience",
          getStartedDes2:
            "Start using the platform effortlessly without complex training, thanks to an intuitive interface and a clean design that helps you manage meetings and generate minutes in simple steps.",

          collab: "Decisions Are Never Lost",
          collabDes:
            "Keep all meeting minutes and their versions in one central place, with fast search and instant retrieval anytime, ensuring seamless access to information so no decision gets lost.",

          startTrail: "Start Your Free Trial",

          collab2: "Arabic-Focused AI",
          collabDes2:
            "Leverage AI technologies designed to support the Arabic language accurately, turning recordings into clear, structured minutes while preserving discussion context and phrasing quality.",

          // New Content -------------------------------------------------
          forWhomTitle: "Who is Mahdar Designed For?",
          forWhomDes:
            "Designed for any organization needing structured and reliable meeting documentation.",
          audienceBoards: "Board of Directors",
          audienceCommittees: "Committees",
          audienceExecutive: "Executive Teams",
          audienceCompanies: "Companies",
          audienceGov: "Government Entities",
          audienceAssociations: "Associations & Non-Profits",

          challengesTitle: "Challenges Mahdar Solves",
          challengesDes:
            "Mahdar eliminates daily hassles in meeting management and documentation.",
          challenge1: "Lost recommendations after meetings",
          challenge2: "Delays in drafting meeting minutes",
          challenge3: "Difficulty tracking tasks and assignments",
          challenge4: "Manual, paper-based approval of minutes",
          challenge5: "File fragmentation across emails and messaging apps",
        },
        blogsPage: {
          blogDetail: "Blog Details",
          latestArticles: "Latest Articles",
          articleDescription:
            "Thoughtful perspectives on technology, design, business, and life.",
          backToBlogs: "Back to Blogs",
          blogNotFound: "Blog Not Found",
          relatedArticles: "Related Articles",
          lastUpdated: "Last updated",
          Created: "Created",
          readArticle: "Read article",
        },
        contact: {
          TitleContact: "Do you want to improve your company's meetings?",
          SubTitleContact:
            "Our team is ready to answer all your inquiries and assist you in choosing the right solution.",
          getInTouch: "Get in Touch",
          letsChat: "Have a question? Our team is ready to help.",
          fullName: "Full Name",
          firstName: "First Name",
          lastName: "Last Name",
          emailAdd: "Email Address",
          message: "Message",
          leaveUsMessage: "Leave us message",
          sendMessage: "Send Message",
          email: "Email",
          phone: "Phone",
          address: "Address",
          addressValue: "Riyadh, Saudi Arabia",
          faqTitle: "Frequently Asked Questions",
          faqSubTitle:
            "Answers to the most common questions about Mahdar platform",

          faq1Question: "Does the platform support Arabic?",
          faq1Answer:
            "Yes, the platform supports Arabic and uses AI to convert meetings into accurate, clear minutes.",

          faq2Question: "Can the minutes be edited after creation?",
          faq2Answer:
            "Yes, you can review and edit the minutes before approval to ensure all details are accurate.",

          faq3Question:
            "Does the platform support both in-person and virtual meetings?",
          faq3Answer:
            "Yes, the platform supports documenting meetings whether in-person or virtual, by recording them and converting them into professional minutes.",

          faq4Question: "How are minutes approved?",
          faq4Answer:
            "Minutes are approved electronically via Signit, allowing all parties to sign quickly and securely without paper copies.",

          faq5Question: "Is the data secure and encrypted?",
          faq5Answer:
            "Yes, your data is hosted within Saudi Arabia and protected with the latest encryption technologies and security standards, ensuring the highest levels of privacy, compliance, and data protection.",
        },
      },
      linkWorkSpace: {
        search: "Invite by Email or Username",
        sendInvitation: "Send invitation",
        invitationSent: "Invitation sent",
      },
      next: "Next",
      addMeetingAgenda: "Add Meeting Agenda",
      meetingAgenda: "Meeting Agenda",
      addTemplate: "Add Template",
      transcript: "Transcript",
      dialogue: "Dialogue",
      keyPoints: "Key Points",
      highlights: "Highlights",
      chatHistory: "Chat History",
      overview: "Overview",
      approvalStatus: "Approval Status",
      signedBy: "Signed By",
      dateOfApproval: "Date of Approval",
      keyDecisions: "Key Decisions",
      followUpAction: "Follow-Up Action Items",
      meetingMinutesApproval: "Meeting Minutes Approval",
      commentHighlights: "Comment and Highlights",
      addNewSection: "Add New Section",
      addAttachments: "Add Attachments",
      previewDetails: "Preview Details",
      dateTime: "Date & Time",
      hostName: "Host Name",
      forgetPassword: "Forgot Password?",
      backToLogin: "Back to log in",
      printedOn: "Printed on",
      meetingSummaryPDF: "Meeting Summary",
      host: "Host",
      dontForgetToRecord: "Don't forget to record every second",
      noWorriesWillSend: "No Worries we will send you the code for reset",
      enterYourEmail: "Enter your email",
      backToWebsite: "Back to website",
      createAnAccount: "Create an account",
      enterYourPassword: "Enter your password",
      iAgreeToThe: "I agree to the",
      termsAndConditions: "terms and conditions",
      privacyPolicy: "privacy policy",
      createAccount: "Create Account",
      registrationComplete: "Registration Complete",
      registrationThankYouMessage: "Thank you for registering with Minutes!",
      continueToLogin: "Continue to Login",
      backToHome: "Back to Home",
      needHelp: "Need help?",
      contactSupport: "Contact Support",
      orRegisterWith: "Or register with",
      rescheduleMeeting: "Reschedule Meeting",
      reschedule: "Reschedule",
      cancelMeeting: "Cancel Meeting",
      invitedMembers: "Invited Members",
      fileTypeNotSupported: "Extenstion of {{fileName}} not supported",
      trialReminder: "Your free trial ends in {{days}} days.",
      upgradeFeature: "Upgrade now to keep using all features.",
      subscriptionExpiringSoon:
        "Your subscription expires in {{days}} day(s). Renew now to avoid interruption.",
      subscriptionExpired:
        "Your subscription has expired. Please renew to continue using the platform.",
      forbiddenTitle: "Access Forbidden",
      forbiddenDescription:
        "You do not have permission to access this page right now.",
      noActiveSubscription:
        "Your subscription is not active. Please renew your plan to continue using Minutes features.",
      autoEndMeetingUpgradeMessage:
        "Your meeting will end automatically. To continue hosting longer meetings, please upgrade your plan.",
      upgradeNow: "Upgrade Now",
      upgradeMeetingCount:
        "The trial plan allows up to 3 meetings. To create an additional meeting, please upgrade your plan.",
      upgradeUsersCount:
        "The trial plan allows up to 3 users per account. Upgrade your plan to add more users.",
      upgradeAiGeneratedMinutes:
        "AI-generated meeting minutes are not available on the trial plan. Upgrade your plan to enable this feature.",
      upgradeAiMeetingReachedQuota:
        "You have reached your available AI meeting minutes limit. Upgrade your plan to get more minutes.",
      acceptanceNeeded: "Acceptance needed",
      search: "Search",
      startSearching: "Start searching",
      multipleWorkspaces: "Multiple workspaces",
      companyTimezone: "Company timezone",
      seeMore: "See more",
      abstain: "Abstain",
      yes: "yes",
      no: "no",
      select: "Select",
      offline: "Offline",
      beforeMeeting: "Before the meeting",
      accept: "Accept",
      ago: "ago",
      update: "Update",
      join: "Join",
      joinMeeting: "Join Meeting",
      TheRunningMeetingIs: "The Ongoin Meeting Now is: {{name}}",
      required: "Required",
      due: "due",
      more: "More",
      signature: "Signature",
      availableShares: "Available shares",
      aprove: "Approve",
      approved: "Approved",
      started: "Started",
      ended: "Ended",
      invitationTo: "Invitation to",
      accepted: "Accepted",
      addParticipants: "Add participants",
      add: "Add",
      addSection: "Add section",
      addSubsection: "Add subsection",
      editSubsection: "Edit subsection",
      addFile: "Add file",
      editMore: "Edit more",
      saveNewDate: "Save new date",
      updateSubsection: "Update subsection",
      agenda: "Agenda",
      close: "Close",
      create: "Create",
      logout: "Log Out",
      resentcode: "Resent code",
      invalidcode: "Invalid code",
      resetlinksuccess: "The OTP has been sent via email",
      loginsuccess: "Login successful",
      hello: "Welcome",
      members: "members",
      workspace: "workspace",
      from: "from",
      meetingAddress: "Meeting address",
      previousDay: "previous day",
      nextDay: "next day",
      loadMore: "load more",
      delete: "Delete",
      editDescription: "Edit description",
      type: "Type",
      category: "Category",
      public: "Public",
      private: "Private",
      priority: "Priority",
      login: "Log in",
      welcome: "Welcome Back!",
      reset: "Reset",
      edit: "Edit",
      end: "End",
      return: "Return",
      forgotPassword: "Forgot your password?",
      googleConnect: "Connect Google Calendar",
      syncGoogleCalendar: "Sync Google Calendar",
      seeSummary: "See summary",
      seeSummaryAndSign: "See summary and sign",
      timestamp: "Timestamp",
      mention: "Mention",
      decision: "Decision",
      remove: "Remove",
      activate: "Activate",
      deactivate: "Deactivate",
      recentActivity: "Recent activity",
      resetPassword: "Reset password",
      password: "Password",
      confirmPassword: "Confirm Password",
      save: "Save",
      draft: "Draft",
      pending: "Pending",
      seeDetails: "See details",
      cancel: "Cancel",
      email: "Email",
      phone: "Phone",
      origin: "Origin",
      wrong: "Wrong",
      replace: "Replace",
      files: "Files",
      reject: "Reject",
      rejectReason: "Reason for rejection",
      shares: "Shares",
      share_one: "Share",
      share_other: "Shares",
      vote: "Vote",
      vote_other: "Votes",
      share: "Share",
      voteWeight: "Vote weight",
      location: "Location",
      privateMeeting: "Private meeting",
      newMeeting: "New meeting",
      editMeeting: "Edit meeting",
      clearFilters: "Clear filters",
      createPoll: "Create a voting",
      createTask: "Create new task",
      createWorkspace: "Create a workspace",
      scheduleMeeting: "Schedule a Meeting",
      scheduleNewMeeting: "Schedule Meeting",
      scheduleMeetingLater: "Schedule for later",
      instantMeeting: "Instant Meeting",
      assignTask: "Assign task",
      createMeeting: "Create meeting",
      updateMeeting: "Update meeting",
      updateSummary: "Update summary",
      localMeeting: "Local meeting",
      localTime: "Local time",
      createDraft: "Create draft",
      uploadDocument: "Upload document",
      upload: "Upload",
      onlyNumbers: "Only numbers",
      users: "Users",
      usersProfile: "Users Profile",
      usersFrom: "Users from",
      role: "Role",
      editProfile: "Edit profile",
      allRoles: "All roles",
      addAll: "add all",
      addNewUser: "Add New User",
      editUser: "Edit User Details",
      searchUser: "Start typing name",
      noResults: "No results",
      participant_one: "Participant",
      participant_other: "Participants",
      invited_users: "Invited Users",
      user_one: "User",
      user_other: "Users",
      guest_other: "Guests",
      guest_one: "Guest",
      fileError: "This file name already exist",
      today: "Today",
      yesterday: "Yesterday",
      older: "older",
      add_performers: "Add performer",
      add_presenters: "Add presenter",
      addPresenter: "Add presenter",
      performers: "performers",
      presenters: "{{numbers}} Presenters",
      duration: "Duration",
      templateCreated: "Template Created Successfully",
      templateUpdated: "Template Updated Successfully",
      templateDeleted: "Template Deleted Successfully",
      recordingStopped: "Recording & AI transcirpt stopped",
      AITranscirptDisabled: "AI transcirpt disabled",
      recordingStarted: "Recording & AI transcirpt started",
      AITranscirptEnable: "AI transcirpt enable",
      invitiationTo: "Invitation to",
      details: "details",
      description: "Description",
      addDescription: "Add description",
      userNotActive: "This user is inactive now.",
      performingConditions: "Performing conditions",
      workspacePresencePlaceholder:
        "If you want to decline the invitation, please give a reason",
      workspacePrenanceValidation: "Reason is needed",
      invitationDeclined: "Invitation declined",
      invitationAccepted: "Invitation accepted",
      reviewer_other: "Reviewers",
      reviewer_one: "Reviewer",
      poolsAndVotings: "Votings",
      activeTasks: "Active tasks",
      pageingInfo: "Showing {{from}} - {{to}} from {{total}}",
      viaEmail: "Via email",
      viaSms: "Via SMS",
      inactive: "Inactive",
      quorum: "Quorum",
      vote_weight: "Vote Weight",
      invitations: "Invitations",
      dueDate: "Due date",
      onlyUnread: "Only unread",
      currentLifecycle: "Current lifecycle",
      titleOfMotion: "Title of motion",
      titleOfAgenda: "Add agenda title",
      permissionsChanged: "Your permissions changed",
      deactivateUserMessage: "Are you sure you want to remove ( {{name}} ) ?",
      deactivateUserMessageDescription:
        "Removing this user will result in them no longer having access to the workspace. Please confirm this action before proceeding.",
      waitingForResponse: "waiting for response",
      participants: "Participants",
      talkTime: "Talk Time",
      leave: "Leave",
      participant: "Participant",
      selectCategory: "Select Category",
      agendaItems: "Agenda Items",
      newMeetingRoles: {
        participants: "{{numbers}} For participants",
        guests: "{{numbers}} For guests",
        reviewers: "{{numbers}} Reviewers",
      },
      quorumTypes: {
        majority_number: "Majority of number in company",
        majority_shares: "Majority of shares in company",
        majority_number_company: "Majority of number in company",
        majority_shares_company: "Majority of shares in company",
        majority_mixed: "Majority of number and shares in company",
        cumulative_voting: "Cumulative voting",
        majority_number_workspace: "Majority of number in workspace",
        majority_shares_workspace: "Majority of shares in workspace",
      },
      taskPriority: {
        low: "Low",
        normal: "Normal",
        important: "High",
        critical: "Critical",
      },
      meetingOperation: {
        text: "Text",
        voting: "Voting",
        task: "Task",
        votingResults: "Voting results",
        taskResults: "Task results",
      },
      createWorkspacePopup: {
        workspaceName: "Workspace Name",
        workspaceType: "Workspace Type",
        visibility: "Visibility",
        dueDate: "Due Date",
        invitedMembers: "Invited Members",
      },
      joinMeetingPage: {
        transScriptRecordingStop: "Transcript stop",
        transScriptRecordingStart: "Transcript",
        meetingTitle: "Meeting Title",
        dateTime: "Date & Time",
        duration: "Duration",
        meetingType: "Meeting Type",
        workspace: "Workspace",
        status: "Status",
        hostName: "Host Name",
        participants: "Participants",
        Copied: "Copied",
        copyLink: "Copy Link",
        sureEndMeeting: "Are you sure you want to end this meeting?",
        sureLeaveMeeting: "Are you sure you want to leave the meeting?",
        endMeeting: "End Meeting",
        leaveMeeting: "Leave Meeting",
        connectingMoment: "Connecting to your meeting, just a moment!",
        meetingAgenda: "Meeting Agenda",
        meetingMinutes: "Meeting Minutes",
        chat: "Chat",
        Stop: "Stop Record & Transcript",
        Record: "Record & Transcript",
      },
      taskStatus: {
        to_do: "To do",
        in_progress: "In progress",
        rejected: "Rejected",
        done: "Done",
      },
      language: {
        button: "Language",
        hello: "Hello {{name}}",
        systemLanguage: "System language",
        english: "English",
        arabic: "Arabic",
      },
      activity: {
        recentActivity: "Recent activity",
        days: {
          today: "today, {{date}}",
          yesterday: "yesterday, {{date}}",
        },
      },
      textCreator: {
        placeholders: {
          title: "Enter text title",
          description: "Enter text description",
        },
      },
      filters: {
        allTasks: "All global tasks",
        allVotings: "All votings",
        allMeetings: "All meetings",
        assignedToMe: "Assigned to me",
        allWorkspaces: "All workspaces",
        myWorkspaces: "My workspaces",
        dueDate: {
          today: "Due today",
          tomorrow: "Due tomorrow",
          thisWeek: "Due this week",
          thisMonth: "Due this month",
          overdue: "Overdue",
        },
      },
      setPassword: {
        setNew: "Set new password",
        passwordSet: "New password set",
        submit: "Set new",
        mustBe8Characters: "must be 8 characters",
      },
      voting: {
        votingOwner: "Voting owner",
        sharesUsed: "Shares used",
        participants: "Participants",
        voteSecrecy: "Vote Secrecy",
        heedMyVote: "Heed my vote",
        quorumType: "Majority Calculation",
        givePower: "Give your power to {{name}}",
        requestVote: "Request {{name}} to vote",
        votingType: "Voting type",
        optionsToChoose: " Number of options to choose",
        optionsToWin: "Number of options to win",
        saveVoting: "Save voting",
        voting: "Voting",
        addElement: "Add element",
        users: "Users",
        addUser: "Add user",
        label: {
          dateStart: "Voting start date",
          dateEnd: "Voting end date",
          votingResult: "Voting result",
        },
        placeholders: {
          name: "Enter voting title",
          option: "Enter voting option",
          note: "The informations added in this field will be visible as a summary of the voting result",
        },
        votingRoles: {
          voting_owner: "Owner",
          voting_voter: "Voter",
          voting_commentator: "Commentator",
          voting_viewer: "Viewer",
          voting_eliminated: "Eliminated",
        },
        actionMessages: {
          created: "Voting created",
          updated: "Voting updated",
          deleted: "Voting deleted",
          statusUpdated: "Status updated",
          noteSaved: "Voting note saved",
          voteTransferred: "Vote transferred",
          remindNotificationSent: "Remind notification sent",
        },
      },
      profile: {
        title: "Profile",
        email: "E-mail",
        phone: "Phone",
        memberOf: "Member of",
        memberOfWorkspaces: "Workspaces",
        location: "Location",
      },
      rolesSelect: {
        general: "General",
        votings: "Votings",
        meetings: "Meetings",
      },
      twoStepAuth: {
        title: "2 step authentication",
        info: "Enter verfication code. We sent it to",
      },
      companyForm: {
        contactInformations: "Contact informations",
        sharesTitle: "Shares",
      },
      roles: {
        manager: "Executive manager",
        member: "Member",
        chief: "Chief Executive Officer",
        boardOfDirectors: "Board Of Directors",
        executiveManagement: "Executive Management",
        auditor: "Auditor",
        regularGeneralAssembly: "Regular General Assembly",
        extraordinaryGeneralAssembly: "Extraordinary General Assembly",
        shareholder: "Shareholder",
        independent: "Independent Board Member",
        executive: "Executive Board Member With Committees",
        guest: "Guest",
        waiting_for_account: "Waiting for an account",
        meeting_organizer: "meeting_organizer",
        meeting_shareholder: "Shareholder",
        meeting_board_of_directors: "Board of Directors",
        meeting_executive_management: "Executive Management",
        meeting_independent_board_member: "Independent Board Member",
        meeting_executive_brd_mbr_com: "Executive Board Member with Committees",
        meeting_auditor: "Auditor",
        meeting_regular_general_assembly: "Regular General Assembly",
        meeting_extraordinary_general_assembly:
          "Extraordinary General Assembly",
        voting_owner: "Voting Creator",
        voting_voter: "Voter",
        voting_commentator: "Commentator",
        voting_viewer: "Viewer",
        voting_eliminated: "Eliminated",
        meeting_admin: "Meeting Admin",
        meeting_owner: "Meeting Owner",
        meeting_secretary: "Meeting Secretary",
        meeting_attendee: "Meeting Attendee",
        meeting_guest: "Meeting Guest",
        meeting_viewer: "Meeting Viewer",
        secretary: "Secretary",
        some_custom_role_mm: "Some custom role MM",
        admin: "Administrator",
        executive_mng: "Executive Management",
        board_director: "Board director",
      },
      notification: {
        remind: "Remind me in 10 min",
        meeting: {
          invitation: {
            inviting: "Inviting person: {{name}}",
            date: "Date: {{date}}",
            form: "Form: ",
          },
        },
      },

      meetingRoles: {
        secretary: "Secretary",
        organiser: "Organiser",
        guest: "Guest",
      },
      userTypes: {
        internal: "Internal",
        external: "External",
      },
      menu: {
        dashboard: "Dashboard",
        home: "Home",
        workspaces: "Workspaces",
        calendar: "Calendar",
        messages: "Messages",
        documents: "Documents",
        tasks: "Tasks",
        votings: "Votings",
        pollsAndVotings: "Votings",
        styleguide: "Styleguide",
        minimize: "Minimize menu",
        settings: "Settings",
        meetings: "Meetings",
        meetings_min: "Meeting Minutes",
        users: "Users",
      },
      dashboards: {
        goodMorning: "Good Morning",
        quickActions: "Quick actions",
        pendingActions: "Pending actions",
        newRequests: "New requests",
        comingUpNext: "Coming up next",
        actionItems: "Action items",
        activityFromWorkspaces: "Activity from the workspaces",
        workspacesUpdates: "Workspaces updates",
        urgent: "Urgent task:",
        youHave: "You Have ",
        meetingsToday: "Meetings Today Lets Schedule a Meeting",
        scheduleMeeting: "Schedule a Meeting",
        upcomingMeetings: "Upcoming Meetings",
        ViewAllmeetings: "View all meetings",
        joinNow: "Join Now",
        meetingUrl: "Paste your meeting url here",
      },
      registerForm: {
        fullName: "Full Name",
        role: "Role",
        userType: "User type",
        addUser: "Add user",
      },
      createMeetingForm: {
        choosePerformersFirst: "First add Performers, then Presenters",
        chooseVotingBefore: "Choose voting before meeting",
        chooseTaskBefore: "Choose task before meeting",
        resultsOfTask: "Results of task before meeting",
        resultOfVoting: "Result of voting before meeting",
        typeTaskName: "Type task name",
        typeVotingName: "Type voting name",
        subsectionDuration: "Subsection duration",
        updateSubsection: "Update subsection",
        addSelected: "Add selected",
        meetingDeleted: "Meeting deleted",
        majorityOfShares: "Majority of shares",
        majorityOfNumber: "Majority of number",
        majorityOfNumberAndShares: "Majority of number and shares",
        meetingCreatorTitle: "Meeting creator",
        titleRequired: "Title is required",
        enterTitle: "Enter meeting title",
        enterDescription: "Enter optional meeting description",
        enterTranscriptSummary: "Enter transcript summary",
        enterSummaryConclusion: "Enter summary conclusion",
        enterMeetingAddress: "Enter meeting address",
        frequencyDaysRequired: "Select days for repeat",
        meetingCreated: "Meeting created",
        meetingUpdated: "Meeting draft updated",
        workspace: "Workspace",
        quorumType: "Quorum Type",
        enterTitlePlaceholder: "Enter title",
        sectionTitleRequired: "Section title is required",
        titleLengthErrorMax: "Title is too long. Max 100 characters",
        titleLengthErrorMin: "Title is too short. Min 1 characters",
        sectionDeleteConfirmation: "Are you sure you want to delete section?",
        deleteConfirmation: "Are you sure you want to delete {{entity}}?",
        updated: "Updated:",
        secondsAgo: "{{seconds}} seconds ago",
        minutesAgo: "{{seconds}} minutes ago",
        updateNow: "Update now",
        saveNow: "Save now",
        peopleInMeeting: "People in meeting",
        guestModal: "Invite external member",
        guestModalAdditionalText:
          "You need to save meeting, until you will invite external member.",
        participantList: {
          removeParticipant: "Remove participant",
          removeUserModalTitle: "Remove Participants",
          removeUserModalHeader:
            "You're about to remove {{name}} from the meeting.",
          removeUserModalSectionText: "This user is currently attending:",
          removeUserModalSubsectionText: "This user is also participating in:",
          confirmationMessage:
            "If you remove the user, they will be removed from the agenda section(s) but will not be removed from any assigned tasks or votes. You will need to remove them manually from the assigned events.",
          ok: "OK",
          cancel: "Cancel",
          genericConfirmationMessage:
            "Are you sure you want to remove {{name}} from meeting?",
          postPoneConfirmationMessage: "Are you sure you want to",
          postpone: "Postpone",
          theMeeting: "the meeting?",
          describereason: "Describe reason",
          reschedule: "reschedule",
        },
        selectCalculationMethod: "Select Method",
        scheduleMeeting: "Schedule a Meeting",
        addTemplate: "Add Template",
        meetingTitle: "Meeting Title",
        date: "Date and Time",
        duration: "Duration",
        meetingType: "Meeting Type",
        addMembers: "Add Members",
        archiveConfirmation: "Are you sure you want to {{entity}}?",
      },
      archive: "Archive",
      viewMeeting: {
        noAccessSection: "You don't have access to this section",
        agenda: {
          lastEdited: "Last edited by {{name}}",
        },
      },
      meetingTypes: {
        by_presence: "By presence",
        remote: "Remote",
      },
      meetingStatus: {
        Draft: "Draft",
        PendingApproval: "Pending Approval",
        PendingReview: "Pending Review",
        Approved: "Approved",
        Started: "Started",
        Ended: "Ended",
        PendingSummaryGenerate: "Pending Summary Generate",
        PendingSummarySign: "Pending Summary Sign",
        SummarySigned: "Summary Signed",
        InvalidMeetingStatus: "Invalid meeting status",
      },
      participantStatus: {
        present: "Present",
        absent: "Absent",
      },
      meetingMessages: {
        remindMeIn: "Remind me in {{min}} min",
        startingInMinutes_one: "Starting in one minute",
        startingInMinutes: "Starting in",
        years: "years",
        months: "months",
        days: "days",
        minutes: "minutes",
        hours: "hours",
        sentToApprova: "Meeting sent to approval",
        startReview: "Started meeting review",
        approve: "Meeting approved",
        disapprove: "Meeting disapproved",
        acceptPresence: "Presence accepted",
        rejectPresence: "Presence rejected",
        successNextSection: "Next section",
        successPreviousSection: "Previous section",
        successSectionMeetingMinutes: "Meeting minutes saved",
        meetingPostponedAction: "Meeting postponed",
        sentForApproval: "Meeting sent for approval",
      },
      meetingAction: {
        approvalSend: "Send draft to approval",
        approval: "Approval",
        disapproval: "Disapproval",
        startReview: "Start review",
        resendInvitation: "Re-send invitation to {{name}}",
        resendInvitationSuccess: "Invitation has been resent ",
      },
      globalSearchActions: {
        search: "Search",
        all: "All",
        Users: "Users",
        Meeting: "Meeting",
      },
      meetingLabels: {
        reason: "Reason",
        rejectReason: "Reject reason:",
        disapprovalTitle: "Disapprove meeting: ",
        rejectInvitationTitle: "Reject meeting invitation: ",
      },
      userRolesSettings: {
        protectedRoleError: "You can't delete protected role",
        assignedRoleError: "You can't delete role that is assigned to user",
        requiredPermissions: "Required permissions",
        rolesPageTitle: "Roles & Permissions",
        searchPlaceholder: "Start typing permission name",
        newRoleAdded: "New role added",
        roleName: "Role name",
        roleDeleted: "Role deleted",
        roleModalDelete: "Are you sure you want to delete role",
        roleNameMaxLength: "Max 50 characters",
        roleDescriptionModalTitle: "You are editing description for role",
        roleUpdated: "Role updated",
      },
      userEditForm: {
        sharesTitle: "Shares",
        personalInformation: "Personal Information",
        totalShares: "Total number of shares",
        sharesToBig: "Must be less or equal {{max}}",
        sharesToBigMore:
          "If you want to add more shares to this user first change the number of shares in another user accordingly",
        sharesToSmall: "Must be greater or equal 0",
        sharesInCompany: "Shares in the company",
        quorumInNumber: "Quorum in number",
        contactInformations: "Contact informations",
        emailAddress: "Email Address",
        phoneNumber: "Phone Number",
        location: "Location",
        country: "Country",
        roleAndPower: "Role & power in meetings",
        save: "Save Changes",
        _2fa: "Enable Two-Factor Authecation",
        workspaceMembership: "Membership in workspaces",
        showUserWorkspaces: "Show user workspaces",
        avatarDeleted: "Avatar deleted",
        votingWeight: "Voting weight",
        govId: "Government ID",
        language: "Language",
      },
      createWorkspaceForm: {
        deleteConformation: "Are you sure you want to delete workspace?",
        usersAdded: "Users invited to workspace",
        nameRequired: "Name is required",
        enterName: "Enter workspace name",
        description: "Workspace description (optional)",
        startTime: "Duration from",
        endTime: "to",
        createWorkspace: "Create workspace",
        editWorkspace: "Edit workspace",
        newWorkspace: "New workspace",
        members: "{{numbers}} Members",
        addMember: "Add member",
        viewDetailsCreateWorkspace: "View Details and Create Workspace",
        workspaceCreated: "Workspace created",
        workspaceUpdated: "Workspace updated",
        workspaceDeleted: "Workspace deleted",
        updateWorkspace: "Update workspace",
        photoText: "Workspace photo",
        nameTooLong: "Name is too long. Max 50 characters",
        descriptionTooLong: "Description is too long. Max 2000 characters",
        endDateRequired: "End date is required",
        userDeleted: "User deleted",
        workspace: {
          named: "Workspace: {{name}}",
          unnamed: "Another workspace",
        },
      },
      addGuest: {
        title: "Add Guest",
        submit: "Add Guest",
        addedGuestError: "Guest is aleady added",
        labels: {
          name: "Name",
          email: "E-mail address",
          phone: "Phone number",
          invitationText: "Invitation text",
        },
        placeholders: {
          name: "Enter name",
          email: "Enter e-mail address",
          phone: "Enter phone number",
          invitationText: "Enter invitation text",
        },
      },
      workspaces: {
        lifeCycle: "Lifecycle",
        seeArchive: "See archive",
        workspace: "workspace",
        createWorkspace: "Create workspace",
        memberOf: "You are currently a member of {{count}} workspaces",
        meetings: "Meetings",
        addMeeting: "Add meeting",
        noMeetingRecords: "No meeting records available",
      },
      notifications: {
        title: "Notifications",
        noData: "You have no new notifications",
        markAllRead: "Mark all as read",
        markAsRead: "mark as read",
      },
      validation: {
        meetingStartTimeInPast: "Meeting start time is in the past",
        taskRequirementIsRequired: "Performing condition is required",
        taskRequirementTooShort:
          "Requirement title is too short. Min 1 characters",
        taskRequirementTooLong:
          "Requirement title is too long. Max 200 characters",
        usersList: "At least one user is required",
        phoneIsInvalid: "Phone number is invalid",
        listIsRequired: "At least one item is required",
        reviewerRequired: "At least one Reviewer is required",
        participantsRequired: "At least one participant is required",
        arrayMinLength: "At least {{length}} is required",
        meetingAddressRequired: "Meeting address is required",
        required: "Required",
        durationMin: "Duration needs a minimum one minute",
        emailIsInvalid: "Email is invalid",
        titleIsRequired: "Title is required",
        titleIsTooLong: "Title is too long. Max 200 characters",
        titleIsTooShort: "Title is too short. Min 1 characters",
        titleEntityIsRequired: "Agenda’s title is required",
        titleEntityIsTooShort: "Agenda’s title is too short. Min 1 characters",
        titleEntityIsTooLong: "Agenda’s title is too long. Max 200 characters",
        elementIsRequired: "Voting option is required",
        elementIsTooLong: "Voting option is too long. Max 200 characters",
        elementIsTooShort: "Voting option is too short. Min 1 characters",
        descriptionIsRequired: "Description is required",
        descriptionCurrentAndMaxLength:
          "Description has {{current}}/{{max}} characters",
        descriptionIsTooLong: "Description is too long. Max 2000 characters",
        descriptionIsTooShort: "Description is too short. Min 1 characters",
        passwordIsRequired: "Password is required",
        passwordMinLength: "Password is too short. Min 8 characters",
        passwordOneBigLetter: "Password must contain at least one big letter",
        passwordOneSmallLetter:
          "Password must contain at least one small letter",
        passwordOneNumber: "Password must contain at least one number",
        passwordRepeatNotMatch: "Passwords do not match",
        votingOptionIsRequired: "Voting option is required",
        votingOptionIsTooLong: "Voting option is too long. Max 100 characters",
        votingUsers: "Add at least one User",
        pastDate: "Date is past",
        listMinTwoAreRequired: "At least two items are required",
        oneSpeakerRequired: "At least one speaker is required",
        oneUserRequired: "At least one user is required",
      },
      taskForm: {
        conditionItem_one: "{{count}}st condition",
        conditionItem_two: "{{count}}nd condition",
        conditionItem_few: "{{count}}rd condition",
        conditionItem_other: "{{count}}th condition",
        usersTitle: "{{numbers}} Performers",
        saveTask: "Save task",
        dueDate: "Date to perform",
        performingConditions: "Performing conditions",
        addElement: "Add element",
        taskDescription: "Task description",
        newTask: "New task",
        taskCreated: "Task created",
        taskDeleted: "Task deleted successfully",
        conditions: "Conditions",
        beforeChoosePresenters:
          "Before you choose presenters, choose them as performers",
        requirementDeleted: "Requirement deleted",
      },
      recordedMettings: {
        registration: "Click Here to Registration",
        join: "Join",
      },
      milestoneForm: {
        milestoneCreated: "Task created",
        milestoneMovedToWorkspace: "Task moved to workspace",
        moveToWorkspace: "Move to workspace",
      },
      tasksPage: {
        task: "Task",
        tasks: "Tasks",
        assignedTo: "Assigned to",
        createCustomTask: "Create custom task",
        status: "Status",

        categories: {
          all: "All current tasks",
          vote: "Surveys/Polls",
          surveys: "Surveys",
          signatures: "Signatures",
          docApprovals: "Document Approvals",
          custom: "Custom tasks",
          meeting: "Meetings",
          done: "Done",
        },
      },
      calendarPage: {
        calendar: "Calendar",
        newMeeting: "New meeting",
        noResults: "No results",
        clearDates: "Clear dates",
        workspaceSelectPlaceholder: "Workspace",
        seeFuture: "See future meetings",
        seePast: "See archived meetings",
      },
      taskPage: {
        finishAllRequirements: "Finish all requirements first",
        due: "due",
        priority: "priority",
        done: "Done",
        markAsDone: "Mark as done",
        markAsNotDone: "Mark as not done",
        taskStatusChanged: "Task status changed",
        requirementStatusChanged: "Requirement status changed",
        changeStatus: "Task status changed",
        reason: "Reason",
        rejectTask: "Reject task",
      },
      liveMeeting: {
        approximatedTime: "Approximated time",
        postponeText:
          "Choose new date for this meeting. Agenda and members will be the same.",
        postponeTitle: "Change meeting date",
        onGoing: "Ongoing",
        participants: "participants",
        participant: "participant",
        pleaseWait: "Please wait...",
        noAccess: " You don’t have acces to this agenda section.",
        meetingNotStarted:
          "The meeting has not started yet. Wait for it to start...",
        join: "Join to the meeting now",
        startMeeting: "Start Meeting",
        waitMoment: "Wait for moment",
        wantToStart: "Are you want to start?",
        wantToJoin: "Want to join?",
        agenda: "Agenda",
        quorumReached: "Quorum has been reached",
        quorumNotReached: "Quorum has not been reached",
        changeMeetingDate: "Change meeting date",
        meetingMinutes: "Meeting minutes",
        endThisSectionAndStartNext: "End this section and start next",
        meetingEnded: "The meeting has ended",
        backToPrevious: "Back to previous",
        noSlots: "Currently no slots available",
        bottomBar: {
          more: "More",
          agenda: "Agenda",
          record: "Record",
          mute: "Mute",
          unmute: "Unmute",
          stopVideo: "Stop video",
          startVideo: "Start video",
          screenShare: "Screen Share",
          endCall: "End call",
          leaveMeeting: "Leave meeting",
          endMeeting: "End meeting",
          voting: "Voting",
          chat: "Chat",
          participants: "Participants",
          raiseHand: "Raise hand",
          stopScreenShare: "Stop Share",
        },
      },
      votingsPage: {
        title: "Votings and surveys",
        create: "Create",
        newVoting: "New Voting",
        before: "before",
        categories: {
          all: "All current surveys",
          votings: "Votings",
          questionnaires: "Questionnaires",
        },
        votingSession: "Voting session",
        questionnary: "Questionnary",
        meeting: "Meeting",
        barAttending: "Are you attending?",
        options: "Voting options",
        results: "Voting results",
        votingLiveRoomSwitch: "With live room?",
      },
      liveVoting: {
        saveNote: "Save note",
        votingLive: "Voting live",
        voting: "Voting",
        noVoting: "No voting",
        noAvailableVotes: "You have no available votes or your votes are used",
        sendAnswer: "Send answer",
        startVoting: "Start voting",
        endVoting: "End voting",
        abstain: "Abstain from voting",
        shares: "Shares",
        vote_zero: "{{count}} vote",
        vote_one: "{{count}} vote",
        vote_other: "{{count}} votes",
        people_zero: "{{count}} person",
        people_one: "{{count}} person",
        people_other: "{{count}} people",
        votingNotStarted:
          "The voting has not started yet. Wait for it to start...",
        join: "Join to the voting now",
        votingEnded: "Voting has ended",
        waitMoment: "Wait for moment",
        peopleNotVotedTitle: "Not voted",
        requestToVote: "Request to vote",
      },
      votingSummary: {
        approved: "Voting summary was approved",
        signed: "and signed",
        votingType: "Voting type",
        voting: "Voting",
        results: "Results",
        approvalRequestedAction: "Voting summary approve requested",
        approvedAction: "Voting summary approved",
        disapprovedAction: "Voting summary rejected",
        secret: "Secret",
        vote: "vote",
        votes: "votes",
        downloadedAction: "Voting summary downloaded",
        sentToSignAction: "Voting summary sent to sign",
        signedAction: "Signed voting summary uploaded",
        addConclusion: "Add conclusion",
        editConclusion: "Edit conclusion",
        uploadTitle: "Sign meeting summary",
        uploadText: "Download summary, sign it and upload scan here to sign.",
        conclusionUpdated: "Updated voting summary conclusion",
        conclusions: "Conclusions",
        editNote: "Edit note",
        creator: "Creator",
        submissionTitle: "Submission and approval",
      },
      meetings: {
        meetings: "Meetings",
        calendar: "Calendar",
        recordings: "Recordings",
        Upcoming: "Upcoming Meetings",
        ongoing: "On Going Meetings",
        ended: "Ended Meetings",
        newMeeting: "New Meetings",
        search: "Search",
        meetingsMinutes: "Meetings Minutes",
        newest: "Newest",
        oldest: "Oldest",
        downloadPDF: "Download PDF",
        viewMinutes: "View Minutes",
      },
      scheduleMeetingPopup: {
        scheduleMeeting: "Schedule a Meeting",
        meetingTitle: "Meeting Title",
        meetingDescription: "Meeting Description",
        transcriptSummary: "Transcript Summary",
        summaryConclusion: "Summary Conclusion",
        dateAndTime: "Date and Time",
        duration: "Duration",
        workspace: "Workspace",
        meetingType: "Meeting Type",
      },
      meetingSummary: {
        addConclusion: "Add conclusion",
        viewSummary: "View Summary",
        editConclusion: "Edit conclusion",
        conclusion: "Conclusion",
        conclusionUpdated: "Conclusion updated",
        quorum: "Quorum reached",
        notReached: "Quorum has not been reached",
        signedSummaries: "Signed summaries",
        usersInvitedToApprove: "Users invited to approve",
        attendances: "Attendances",
        agenda: "Agenda",
        invite: "Invite",
        minutesApprovedAction: "Meeting minutes approved",
        minutesDisapprovedAction: "Meeting minutes rejected",
        minutesRequestedAction: "Meeting minutes approve requested",
        minutesSentToSignAction: "Meeting minutes sent to sign",
        minutesDownloadedAction: "Meeting summary downloaded",
        inviteAcceptMeetingSummary: "Invite to Accept Meeting Summary",
        searchUsers: "Search Users",
        invitationSent: "Invitation Sent",
        sendInvitation: "Send Invitation",
        noteEditedAction: "Meeting notes edited",
        plannedTime: "Planned time",
        meetingNotFound: "Meeting not found",
        sign: "Sign",
        sendToSign: "Send to signature",
        accept: "Accept summary",
        reject: "Reject",
        votingNotEnded: "Voting is not ended",
        suggestChanges: "Suggest changes",
        inviteToAcceptance: "Invite to acceptance",
        sendToApproval: "Send To Approval",
        approveSummary: "Approve summary",
        approved: "Meeting summary was approved",
        signed: "and signed",
        presentUsers: "The following people were present",
        absentUsers: "The following people were absent",
        hideDocument: "Hide document",
        showDocument: "Show full document",
        submissionTitle: "Submission and approval of minutes",
        minutesSubmited: "Minutes submitted by",
        minutesApproved: "Minutes approved by",
        minutesRejected: "Minutes rejected by",
        presenters: "{{numbers}} Presenters",
        participants: "{{numbers}} Participants",
        votingResults: "Voting results",
        attachments: "Attachments",
        meetingType: "Meeting type",
        workspace: "Workspace",
        date: "Date",
        time: "Time",
        rejected: "Rejected",
        download: "Download summary",
        downloadSignedSummary: "Download signed summary",
        edit: "Edit summary",
        waitingForApproval: "Waiting for approval",
        waitingForSign: "Waiting for sign",
        day_one: "day",
        day_other: "days",
        week: "week",
        dontSetTime: "Don't set a time",
        addMembers: "Add members",
        editMode: "Edit mode",
        save: "Save changes",
        clickToEdit: "Click on the items you want to edit",
        uploadTitle: "Sign meeting summary",
        uploadText: "Download summary, sign it and upload scan here to sign.",
        timeTitle: "Set time for acceptance",
        timeText: "Select until when the summary can be accepted",
        waitUntillEditNoteFinished: "Wait untill it's finished to edit note",
        isEditingNow: "is editing now.",
      },
      maxFileSizeIs: "Max uploaded file should be {{size}}MB",
      liveParticipants: {
        noParticipants: "No participants",
        participants: "Participants",
        guests: "Guests",
        declined: "Declined",
        online: "Online users",
      },
      settings: {
        basic: "Basic",
        users: "Users",
        companyData: "Company data",
        basicDescription: "Informations about your company",
        usersList: "Users list",
        usersDescription:
          "You can add, delete or edit users from your company.",
        rolesAndPermissions: "Roles & permisions",
        setPermissions: "Set permissions to roles in your app.",
      },
      settingPage: {
        meetingTimeLimit: "Meeting time limit 45 Minute",
        meetingTimeLimitU: "Meeting time limit Unlimited Minute",
        meetingTimeLimit20: "Meeting Duration: 20 hours",
        meetingTimeLimit30: "Meeting time limit 30 hours",
        meetingTimeLimit50: "Meeting time limit 50 hours",
        viewDownloadMeetingMinutes: "View & Download Meeting Minutes",
        dashboardForUpcomingMeetings: "Dashboard for Upcoming Meetings",
        scheduleMeetings: "Schedule Meetings",
        createAgenda: "Create Agenda",
        addParticipants3: "Add Participants: 3",
        addParticipants12: "Add Participants: 100",
        allFeatureOfFreePlan: "All features of the Free Plan, plus:",
        allFeatureOfFirstPlan: "All features of the Mahdar Plus, plus:",
        allFeatureOfThirdPlan: "All features of the Mahdar Pro, plus:",
        addParticipants300: "Add Participants: up to 300",
        addParticipants50: "Add Participants: up to 50",
        fullMeetingSummaryFlow: "Full Meeting Summary Flow",
        mailNotifications: "Mail Notifications",
        userlimit3: "User limit: up to 3",
        userlimit100: "User limit: up to 100",
        userlimit300: "User limit: up to 300",
        userlimit50: "User limit: up to 50",
        recordedMeeting: "Meeting Recording",
        meetingLimit3: "Meeting’s Limit: up to 3",
        meetingLimitU: "Unlimited Video Meetings",
        eSignatureMinutes: "E-Signature for Minutes (Paid Service)",
        videoMeeting45Each: "Video Meetings (45 minutes each): 3",
        signatureAtAdditionalCost: "Signature available at an additional cost",
        eSignature: "E-Signature:",
        notifications: "Notifications",
        createDepartments: "Create Departments (Workspaces)",
        aiMeetingPlan: "AI Meeting Minute’s:",
        aiMeeting6: "AI Meeting Minute’s: up to 0 minutes",
        aiMeeting180: "AI-Powered Minutes Drafting: 180 minutes",
        aiMeeting400: "AI Meeting Minute’s: up to 400 minutes",
        aiMeeting800: "AI Meeting Minute’s: up to 800 minutes",
        aiMeeting: "Additional AI Meeting’s (Paid Service)",
        publicURL: "Share Meeting Link",
        instantMeetingOnly: "Instant Meeting Minutes",
        settings: "Settings",
        personalInformation: "Personal Information",
        accountSecurity: "Account Security",
        departments: "Departments",
        subscriptionAndBilling: "Subscription and Billing",
        roleManagement: "Role Management",
        chat: "Live Chat Support",
        templateManagement: "Template Management",
        basicDetails: "Basic Details",
        security:
          "Standard security with data encryption for meetings, chats, calls and files",
        currentPassword: "Current Password",
        addNewPassword: "Add New Password",
        confirmNewPassword: "Confirm New Password",
        ChooseYourRightPlan: "Choose your right plan!",
        youHave: "You Have",
        permission: "Permission",
        createMeetings: "Create meetings",
        joinMeetings: "Join meetings",
        recordings: "Recordings",
        tryNow: "Try Now",
        subscribeNow: "Subscribe Now",
        startForFree: "Start for Free",
        tryTeam: "Try it for your team",
        startProfessional: "Start with professionalism",
        requestCustomPlan: "Request a customized offer",
        subscribed: "Subscribed",
        activated: "Activated",
        mostPopular: "Most Popular",
        meetingAI: "Meeting AI",
        userName: "User Name",
        email: "Email",
        currentRole: "Current Role",
        addedOn: "Added On",
        admins: "Admins",
        members: "Members",
        viewers: "Viewers",
        newTemplate: "New Template",
        calendar: "Calendar for Scheduled Meetings",
        storage: "Cloud Storage - 5GB",
        freePlan: "Free Plan",
        mahdarPlus: "Mahdar Plus",
        mahdarPro: "Mahdar Pro",
        mahdarMax: "Mahdar Max (Ultimate)",
        sar: "SAR",

        // 2nd plan
        meetingRecording: "Meeting Recording",
        aiPoweredMinutesDrafting180: "AI-Powered Minutes Drafting: 180 minutes",
        calendarForScheduledMeetings: "Calendar for Scheduled Meetings",
        cloudStorage5GB: "Cloud Storage: 5 GB",
        attachDocumentsToMinutes: "Attach Documents to Minutes",
        advancedSecurityAndDataEncryption:
          "Advanced Security and Data Encryption",
        liveChatSupport: "Live Chat Support",

        // 3rd plan
        upcomingMeetingDashboard: "Upcoming Meetings Dashboard",
        meetingDuration: "Meeting Duration: 20 hours",
        aiPoweredMinutesDrafting: "AI-Powered Minutes Drafting: 400 minutes",
        meetingScheduling: "Meeting Scheduling",
        customWorkspaces: "Custom Workspaces",
        certifiedElectronicSignature:
          "Certified Electronic Signature (Paid Service)",
        textChatDuringVideoMeetings: "Text Chat During Video Meetings",

        // 4th plan
        addParticipants: "Add Participants: 300",
        meetingDuration4thPlan: "Meeting Duration: 50 hours",
        aiPoweredMinutesDrafting4thPlan:
          "AI-Powered Minutes Drafting: 800 minutes",
        meetingMinutesTemplates: "Meeting Minutes Templates",
        directCallSupport: "Direct Call Support During Business Hours",
        customizedOnboardingTraining: "Customized Onboarding Training",
        upgradePlan: "Upgrade Plan",
      },
      linkingWorkspaces: {
        openModalText: "Link with other workspace",
        modalTitle: "Choose workspace to link",
        modalPlaceholder: "Type workspace name",
        modalValidation: "Please select a workspace",
        modalApprove: "Send a linking request",
        unlinkNow: "Unlink now",
        requested: "Requested",
        rejected: "Rejected",
        linked: "Linked",
        by: "by",
        invitationText: "wants to connect this workspace with",
      },
      errorPage: {
        title: "Page not found",
        subtitle: "This page doesn't exist or was removed.",
        backButton: "Back to system dashboard",
      },
      lexicalEditor: {
        addComment: "Add comment",
        editComment: "Edit comment",
        yourComment: "Your comment",
        selectTextToComment: "Select the text you want to comment",
      },
      errors: {
        somethingWentWrong: "Something went wrong",
        errorCreatingTask: "Error creating Task",
        filesUploadError: "Error while uploading files",
        subsectionPostError: "Error while creating subsection",
      },
      createTemplateForm: {
        addTemplate: "Add Template",
        editTemplate: "Edit Template",
        titleRequired: "Title is requried",
        nameTooLong: "Name is too long. Max 50 characters",
        agendaRequired: "Agenda is required",
        categoryRequired: "Category is required",
        descriptionTooLong: "Description is too long. Max 2000 characters",
        enterMeetingTitle: "Enter Meeting Title",
        description: "Template description (optional)",
        createTemplate: "Create",
        updateTemplate: "Update",
        confirmDelete: "Are you sure you want to delete the template?",
        viewTemplate: "View Template",
      },
      meetingList: {
        title: "Meeting Title",
        type: "Type",
        status: "Status",
        workspace: "Workspace",
        creator: "Hosted By",
        startDate: "Meeting Date Time",
      },
      departmentList: {
        lifeCycle: "Life Cycle",
        totalMembersInWorkspace: "Total Members in Workspace",
        name: "Workspace Name",
        createdBy: "Created By",
        totalMembers: "Total Members",
        creationDate: "Creation Date",
        actions: "Actions",
      },
      adminUser: {
        userDetails: "User Details",
        seeDetails: "See Details",
        company: "Company",
        status: "Status",
        trailEnds: "Trail Ends",
        actions: "Actions",
        memberOfAdmins: "You are currently {{count}} members",
        basicInfo: "Basic Info",
        userId: "User ID",
        name: "Name",
        email: "Email",
        isAdmin: "Admin",
        companyInfo: "Company Info",
        packageName: "Package",
        subscription: "Subscription",
        trial: "Trial",
        daysRemaining: "Days Remaining",
        timestamps: "Timestamps",
        createdAt: "Created At",
      },
    },
  },
  ar: {
    translation: {
      noDataFound: "لم يتم العثور على بيانات",
      addReasonHere: "أضف سببًا هنا",
      rejectMeeting: "رفض الاجتماع",
      calendarHomeText:
        "تحقق من كل شيء في هذه الصفحة حول اجتماعاتك القادمة والأخيرة والماضية مع التفاصيل",
      expend: "الإنفاق",
      meetingRecords: "سجلات الاجتماع",
      viewAgenda: "عرض جدول الأعمال",
      createdBy: "تم إنشاؤه بواسطة",
      profileUpdated: "تم تحديث الملف الشخصي",
      name: "اسم",
      meetingExpired: "انتهت مدة الاجتماع.",
      passwordReset: "إعادة تعيين كلمة المرور",
      weSentCode: "أرسلنا الرمز إلى",
      didntReceiveEmail: "لم يستلم البريد الإلكتروني؟",
      clickResend: "انقر لإعادة الالتزام",
      continue: "يكمل",
      and: "و",
      sliderTitle1: "حوّل اجتماعاتك إلى تجربة أكثر ذكاءً وتنظيماً مع محضر",
      sliderDes1:
        " منصة متكاملة لإدارة الاجتماعات، تتيح لك أدوات تعاون متقدمة، ملخصات ذكية مدعومة بالذكاء الاصطناعي، وتسجيلات دقيقة تساعدك على التركيز واتخاذ قرارات أفضل.",
      free: "مجانًا",
      basic: "الباقة الأساسية",
      businessStarter: "باقة رواد الأعمال",
      businessStandard: "الباقة القياسية للأعمال",
      businessPlus: "الباقة المتقدمة للأعمال",
      trialAlreadyUsed: "التجربة المستخدمة بالفعل",
      export: "يصدّر",
      deleteWorkspace: "حذف مساحة العمل",
      updatePassword: "تحديث كلمة المرور",
      noAgendaFound: "لم يتم العثور على أجندة",
      pleaseAddMeetingUrl: "الرجاء إدخال عنوان URL صالح",
      enterOtp: " أدخل رمز التحقق",
      yourScheduledMeetings: "اجتماعاتك المجدولة",
      startTrial: "إبدأ الاجتماع",
      enjoyExtendedMeetingDurations:
        "استمتع بدوريات اجتماعات ممتدة وأدوات تعاون متقدمة وملخصات اجتماعات مدعومة من الذكاء الاصطناعى مع تجربة مجانية لمدة شهر واحد من نصار واحد قسط",
      unlockPremiumNassarMeetFeatures: "فتح قسط ناسار تلبية ميزات",
      pasteMeetingUrl: "الصق عنوان URL الخاص بك في الاجتماع هنا",
      instantlyConnectWithYourTeam:
        "انضم لاجتماعك بضغطة واحدة عبر محضر — تواصل فوري، بلا تحميلات، بلا تعقيدات.",
      seamlessVideoCallsMeetingsForEveryone:
        "حلول احترافية لمكالمات الفيديو والاجتماعات لكل المستخدمين",
      meetingCreatedSuccessfully: "تم إنشاء الاجتماع بنجاح",
      fillPreviousAgenda: "يرجى ملء جدول الأعمال السابق أولاً.",
      upComingMeeting: "الاجتماعات القادمة",
      hostedBy: "استضافتها",
      selectCategory: "حدد الفئة",
      agendaItems: "عناصر جدول الأعمال",
      deactivate: "تعطيل",
      deactivateUserMessageDescription:
        " سيؤدي حذف المستخدم إلى عدم تواجده في مساحة العمل، ويجب التأكد من هذا الإجراء قبل المضي فيه قدمًا.",
      deactivateUserMessage: "هل أنت متأكد أنك تريد حذف ( {{name}} )؟",
      areYouSure: "هل أنت متأكد أنك تريد إلغاء التنشيط",
      loginWith: "تسجيل الدخول مع",
      rememberMe: "تذكرنى",
      register: "إنشاء حساب",
      welcome: "مرحبًا بعودتك!",
      haveAccount: "ليس لديك حساب؟",
      allDepartments: "جميع الأقسام",
      viewMore: "عرض المزيد",
      view: "عرض",
      unread: "غير مقروء",
      all: "الجميع",
      allNotif: "الجميع",
      views: {
        month: "شهر",
        week: "أسبوع",
        work_week: "أسبوع العمل",
        day: "يوم",
        agenda: "جدول الأعمال",
      },
      landingPage: {
        minutes: "محضر",
        partners: "شركاء محتملون",
        navbar: {
          getStarted: "ابدأ تجربتك المجانية",
          login: "تسجيل الدخول",
          contact: "اتصل بنا",
          whyUs: "من نحن",
          blogs: "المدونة",
          pricingPlans: "خطط الأسعار",
          home: "الرئيسية",
          community: "المجتمع",
        },
        footer: {
          whyChooseUs: "من نحن",
          termsConditions: "الشروط والأحكام",
          privacyPolicy: "سياسة الخصوصية",
        },
        home: {
          tryBasic: "جرّب الباقة الأساسية لدينا",
          instantMeetHeader:
            "منصة اجتماعات أونلاين متكاملة تبدأ الاجتماع وتُنهيه بمحضر معتمد",
          instantMeetDes:
            // "محضر هي منصة اجتماعات مرئية أونلاين تُعقد داخلها الاجتماعات، ويُسجَّل كل ما يُناقش تلقائيًا باستخدام الذكاء الاصطناعي، ليتم تحويله فور انتهاء الاجتماع إلى محضر رقمي منظم وجاهز للاعتماد بالتوقيع الإلكتروني",
            "أدر اجتماعات مجالس الإدارة، واللجان، والفرق التنفيذية في منصة واحدة تجمع التسجيل، والتفريغ بالذكاء الاصطناعي، وإعداد المحاضر، والاعتماد الإلكتروني، ومتابعة تنفيذ القرارات.",
          startInstantMeet: "ابدأ تجربتك المجانية الآن",
          meetingUrlPlaceholder: "ألصق رابط اجتماعك هنا",
          reviewsNumber: "بناءً على أكثر من 10,000 مراجعة",
          smartSol: "أدر اجتماعاتك من مكان واحد، من التخطيط حتى المحضر المعتمد",
          smartSolDes:
            // "محضر منصة اجتماعات أونلاين متكاملة: تعقد الاجتماع، تديره، وتُصدر محضرًا رسميًا جاهزًا للاعتماد فور انتهائه",
            "لماذا تحتاج إلى محضر؟",
          summary: "الملخص",
          sumTitle:
            // "أنهِ كل اجتماع بمحضر منظم، دقيق، وجاهز للاعتماد — دون أي عمل يدوي",
            "تحويل النقاش إلى محضر احترافي",
          summaryDes:
            "استثمر في كفاءة فريقك: نظامنا المعتمد على الذكاء الاصطناعي يوفر لك ملخصات اجتماعات منظمة واحترافية تلقائيًا. يتم توثيق القرارات الأساسية والمهام المحددة بدقة فائقة لضمان المتابعة الفعالة وتحقيق الأهداف",
          // "kkfkfkf",
          seeFullSummary: "عرض الملخص الكامل",
          agenda: "جدول الأعمال",
          agendaManag:
            //  "خطّط اجتماعك قبل أن يبدأ — ونفّذه كما خُطّط له",
            "اعتماد المحاضر إلكترونيًا",
          agendaDes:
            // "أنشئ جدول أعمال رقمي داخل محضر، حدّد محاور الاجتماع، وزّع الوقت لكل بند، وأرفق الملفات مسبقًا — ليبدأ اجتماعك واضحًا وينتهي بمحضر جاهز للتوقيع",
            "اعتمد المحاضر بسرعة وأمان من جميع الأطراف عبر Signit للتوقيع الإلكتروني، دون الحاجة للطباعة أو تبادل النسخ الورقية، مع حفظ جميع الإصدارات في مكان واحد. ",
          seeFullAgenda:
            "شاهد كيف يتحول جدول الأعمال إلى محضر معتمد خلال دقائق",
          recording: "🤖 الذكاء الاصطناعي",
          recordingTitle:
            //  "من اجتماع مرئي إلى محضر معتمد — في مسار واحد",
            "أرشفة جميع المحاضر",
          recordingAiDes:
            // "أثناء الاجتماع، يحوّل محضر كل ما يُقال إلى ملخص منظم، مهام واضحة، وقرارات جاهزة للتنفيذ — بدون كتابة يدوية.كل اجتماع يصبح مرجعًا رقميًا محفوظًا: تسجيل، نص، ومحضر رسمي يمكن الرجوع إليه في أي وقت.",
            " احتفظ بجميع محاضر الاجتماعات في مكان واحد، مع إمكانية البحث والوصول إليها في أي وقت بسهولة وأمان.",
          aboutMahadar: "كل شيء عن محضر",
          aboutMahadarTitle: "ما هو محضر؟",
          aboutMahadarDes:
            "محضر هو الوثيقة التي يتم إنشاؤها بعد كل اجتماع لتوثيق كل ما حدث بدقة ومهنية. يساعدك على الحفاظ على سير عمل منظم، وضمان متابعة القرارات والمهام، وعكس صورة احترافية لفريقك أو منشأتك.",
          aboutMahadarDes1:
            'يساعدك "محضر" في الحفاظ على تنظيم العمل، وضمان متابعة القرارات والمهام، ويعكس الصورة المهنية لفريقك أو منشأتك.',
          aboutMahadarDes2: 'يتضمن "محضر الاجتماع":',
          aboutMahadarDes3:
            "تفاصيل الاجتماع (العنوان، التاريخ، الوقت، المنظمون، الحضور)",
          aboutMahadarDes4: "جدول الأعمال وما تم مناقشته",
          aboutMahadarDes5: "القرارات النهائية والتكليفات",
          aboutMahadarDes6: "توقيعات الاعتماد والموافقة",
          aboutMahadarDes7: "إمكانية إرفاق المرفقات والمستندات التوضيحية",
          aboutMahadarLink: "تحميل صفحة ملخص تجريبية",
          signTitle: "التوقيع الإلكتروني",
          signDes1: "اعتمد محاضر الاجتماعات رسميًا بسهولة وأمان.",
          signDes:
            "وقّع على محاضر الاجتماعات إلكترونيًا باستخدام واجهة سلسة وموثوقة. سهّل عمليات الموافقة والمتابعة، ووفّر الوقت من خلال توقيعات فورية دون الحاجة للطباعة أو المسح الضوئي. يدعم النظام تتبع التوقيعات وتأكيدها لضمان الامتثال والشفافية الكاملة.",
          seePastSign: "تجربة توقيع رقمية متكاملة وآمنة",
          recordingDes:
            // "أثناء الاجتماع، تقوم المنصة بتحليل النقاش وتحويله إلى محضر واضح يعكس ما تم الاتفاق عليه فعليًا، وتلخيص النقاشات، واستخراج المهام والقرارات بدقة عالية. بعد انتهاء الاجتماع، يكون لديك سجل رسمي موثوق يمكن مشاركته وتوقيعه فورًا تساعد الفرق على التركيز واتخاذ القرارات بكفاءة أكبر.",
            " يحوّل الاجتماع إلى محضر منظم وواضح خلال دقائق باستخدام الذكاء الاصطناعي ، مع توثيق خطة العمل وأهم النقاط بطريقة احترافية وجاهزة للمشاركة.",
          seePastRecording:
            "اجتماع → محضر → توقيع → تنفيذ. كل شيء داخل منصة واحدة.",
          howItWorks: "كيف يعمل؟",
          oneClickMeet:
            "لإجراء اجتماع فوري وموثّق: ابدأ تجربتك المجانية بنقرة واحدة",
          meetInstantly:
            // "ابدأ تجربتك المجانية اجتماعك… وابدأ تجربتك المجانية التوثيق فورًا",
            "أنشئ الاجتماع",
          meetInstantlyDes:
            "أنشئ الاجتماع خلال ثوانٍ، أرسل الرابط، واترك للمنصة مهمة تسجيل النقاش وتحويله تلقائيًا إلى محضر جاهز للتوقيع.",
          meetStartInstant: "ابدأ تجربتك المجانية اجتماعًا فوريًا",

          collab: "سجّل الاجتماع",
          collabDes:
            // `"لتبقى على إطّلاع دائم وتسير بثقة نحو التنفيذ من جدول الأعمال إلى القرارات النهائية — كل شيء محفوظ، منظم، وقابل للرجوع إليه كمرجع رسمي واحد`,
            "سجّل الاجتماع صوتيًا أو مرئيًا، سواء كان حضوريًا أو عن بُعد، ليتم توثيق جميع المداخلات والنقاشات بدقة دون الحاجة إلى تدوين الملاحظات يدويًا.",
          scheduleMeeting: "جدولة اجتماع",
          aiGenTitle: "إنشاء المحضر تلقائيًا",
          aiGenDes:
            //  `"المنصة تحلل الاجتماع بالذكاء الاصطناعي، تستخرج المهام والقرارات، وتحوّلها إلى مخرجات عملية موثقة، مدعومة بالتوقيع الرقمي المعتمد، لتعزيز التعاون وتحقيق نتائج ملموسة بثقة"`,
            "يحوّل الذكاء الاصطناعي تسجيل الاجتماع إلى محضر احترافي يتضمن الحضور، وجدول الأعمال، والتوصيات، وخطة العمل بصياغة واضحة وجاهزة للمراجعة والمشاركة.",
          viewDemoSummary: "عرض ملخص تجريبي",

          chooseBestPlan:
            // "ابدأ تجربتك المجانية مجانًا — ثم توسّع حسب حجم عملك",
            "اعتماد المحضر",
          choosePlanDes:
            //  `"ابدأ تجربتك المجانية بالباقة المجانية، وعندما تحتاج مزيدًا من الاجتماعات أو التوقيع الرقمي، اختر الخطة التي تناسب نموك التشغيلي، ستجد الباقة المناسبة لإدارة الاجتماعات وتحقيق أقصى استفادة"`,
            "راجع المحضر واعتمده إلكترونيًا عبر Signit، ليتم توقيعه من جميع الأطراف بسرعة وأمان، مع حفظ جميع الإصدارات في مكان واحد دون الحاجة إلى الطباعة أو تبادل النسخ الورقية.",
          pricingPlans: "خطط الأسعار",
          testimonials: "آراء المستخدمين",
          whyUseMehdar:
            "اكتشف لماذا يُفضّل المحترفون مُحضر لإنتاجية لا مثيل لها في الاجتماعات",
          mahdar: "محضر",
          mahdarDes: `!لقد غيّر تمامًا الطريقة التي نتعامل بها مع الاجتماعات. توفر لنا الملخصات التي يتم إنشاؤها بواسطة الذكاء الاصطناعي ساعات من تدوين الملاحظات اليدوية، ولا نفوّت أي قرارات مهمة أبدًا`,
          ahmedR: "أحمد ر. – مدير مشروع",
          review2: ".إدارة اجتماعات فريقي عن بُعد لم تكن يومًا أسهل من ذلك",
          review2End: `.بفضل النسخ التلقائي وتتبع عناصر المهام، نظل منظمين ومنتجين دون أي عناء`,
          saraL: "سارة ل. – الرئيس التنفيذي لشركة تك فلو",
          iLoveHow: "أحب كيف",
          review3: `.يُبسّط توثيق الاجتماعات. نستخدمه في المقابلات والمناقشات الجماعية، وتضمن الملخصات المدعومة بالذكاء الاصطناعي التقاط كل التفاصيل المهمة بكل سهولة`,
          davidM: "ديفيد م. – مدير الموارد البشرية",
          ourSocials: "وسائل التواصل الاجتماعي الخاصة بنا",
          footerDes: `محضر منصة اجتماعات أونلاين متكاملة تتيح لك إنشاء الاجتماع، عقده مرئيًا داخل المنصة، ثم الخروج بمحضر اجتماع رقمي جاهز مباشرة بعد الانتهاء.`,
          footerDes1: `تجمع محضر كل ما يتعلق بالاجتماع في مسار واحد دون الحاجة لاستخدام أدوات متعددة؛ حيث يتم تحليل النقاش وتحويل الصوت إلى نص مكتوب تلقائيًا، وربط ما نوقش ببنود جدول الأعمال لإنتاج محضر منظم ودقيق.`,
          footerDes2: `كما تتيح اعتماد المحضر بالتوقيع الإلكتروني، وحفظه ومشاركته كمرجعية واضحة يمكن الرجوع إليها في أي وقت، ضمن بيئة آمنة وسهلة الاستخدام.`,
          footerDes3:
            "محضر ليست أداة تسجيل فقط، بل منصة عمل متكاملة تحوّل الاجتماع من مجرد اتصال مرئي إلى مخرجات واضحة قابلة للتنفيذ.",
          product: "دليل المنصة",
          ourOtherPlatforms: "منصاتنا الأخرى",
          facebook: "فيسبوك",
          linkedIn: "لينكدإن",
          x: "إكس",
          youtube: "يوتيوب",
          instagram: "انستغرام",
          aboutWorkspaces: "كل شيء عن مساحة العمل",
          whatWorkspace: "ما هي مساحة العمل؟",
          whatWorkspaceDes1:
            "مساحة العمل هي وحدة تنظيمية تجمع أعضاء الفريق في مكان واحد لإدارة الاجتماعات، تتبع المهام، وتوثيق العمل ضمن قسم أو مشروع معين.",
          whatWorkspaceDes2: `تُسهم "مساحة العمل" في تسهيل التعاون، توضيح الأدوار، وتعزيز إنتاجية الفريق.`,
          workspaceLink: `A fully organized and collaborative workspace experience`,
          workspaceListingTitle: "تتيح لك مساحة العمل:",
          workspaceListing1: "إنشاء أقسام وفِرق منفصلة داخل المنصة",
          workspaceListing2: "إضافة الأعضاء ومتابعة نشاطهم",
          workspaceListing3: "جدولة الاجتماعات وتوثيق محاضرها",
          workspaceListing4: "تنظيم الملفات والمهام في مكان مركزي واحد",
          workspaceListing5: "تخصيص الأوصاف وتحديد فترة زمنية لكل مساحة عمل",
        },
        pricingPlans: {
          choosePlan: "اختر الخطة المناسبة لعملك",
          rightPlanDes: `سواء كنت تدير فريقًا صغيرًا أو مجلس إدارة أو مؤسسة كبيرة، توفر محضر خططًا مرنة تناسب احتياجاتك مع إمكانية الترقية في أي وقت.`,
          monthly: "شهريًا",
          permissionPer: "لديك إذن بنسبة 50%",
          mostPopular: "الأكثر شيوعًا",
        },
        whyUs: {
          whyChooseUs: "لماذا تختار محضر؟",
          whyChooseUsDes:
            "لأن محضر لا تقدّم مجرد أداة لتسجيل الاجتماعات، بل تمنحك منظومة توثيق ذكية ومتكاملة، ومتوافقة مع احتياجات الأفراد والفرق والجهات الرسمية",

          smart: "وفر وقت فريقك",
          // "اجتماعات فعّالة بنتائج واضحة",
          smartDes:
            // "منصة اتصال مرئي مبتكرة تمكّنك من إصدار محضر اجتماع فوري ودقيق، مع توثيق موثوق عبر التوقيع الرقمي المعتمد، لتسهيل التعاون واتخاذ القرارات بثقة",
            "اختصر الوقت المستغرق في تدوين الاجتماعات وإعداد المحاضر، ودع الذكاء الاصطناعي يحوّل النقاشات إلى محاضر احترافية خلال دقائق، ليتمكن فريقك من التركيز على العمل بدلًا من الأعمال الإدارية.",

          instant: "ارفع جودة الحوكمة",
          instantDes:
            "احرص على توثيق الاجتماعات وخطة العمل والتوصيات وفق آلية موحدة واحترافية، بما يعزز الشفافية ويساعد على تطبيق أفضل ممارسات الحوكمة داخل المنشأة.",
          // "استمتع بتجربة استخدام آمنة، وسهلة بنقرة واحدة، كل التفاصيل محفوظة في بيئة تقنية موثوقة تحفظ ملكيتك تضمن وخصوصيتك",

          getStarted: "عزز المساءلة",
          getStartedDes:
            "حوّل مخرجات الاجتماع إلى خطة عمل  واضحة مرتبطة بالمسؤولين، مع توثيقها وحفظها، مما يسهل متابعة التنفيذ ويعزز وضوح المسؤوليات بين أعضاء الفريق.",
          getStarted2: "تجربة استخدام بسيطة",
          getStartedDes2:
            "ابدأ استخدام المنصة بسهولة دون الحاجة إلى تدريب معقد، من خلال واجهة استخدام واضحة وتصميم يساعدك على إدارة الاجتماعات وإنشاء المحاضر بخطوات بسيطة.",

          collab: "قرارات لا تضيع",
          collabDes:
            // "مصممة لتكون سهلة الاستخدام ، لتمنح كل مستخدم تجربة مرنة، ونتائج احترافية معتمدة ورسمية",
            "احتفظ بجميع محاضر الاجتماعات وإصداراتها في مكان واحد، مع إمكانية البحث السريع والرجوع إليها في أي وقت، لضمان سهولة الوصول إلى المعلومات وعدم فقدان أي قرار.",
          startTrail: "ابدأ تجربتك المجانية تجربتك المجانية",
          collab2: "ذكاء اصطناعي باللغة العربية",
          collabDes2:
            // "مصممة لتكون سهلة الاستخدام ، لتمنح كل مستخدم تجربة مرنة، ونتائج احترافية معتمدة ورسمية",
            "استفد من تقنيات ذكاء اصطناعي تدعم اللغة العربية بدقة، لتحويل التسجيلات إلى محاضر واضحة ومنظمة مع الحفاظ على سياق النقاش وجودة الصياغة.",
          // startTrail: "ابدأ تجربتك المجانية تجربتك المجانية",

          // new Content  -------------------------------------------------
          forWhomTitle: "لمن صُممت محضر؟",
          forWhomDes: "صُممت لكل جهة تحتاج إلى توثيق اجتماعات منظم وموثوق.",
          audienceBoards: "مجالس الإدارة",
          audienceCommittees: "اللجان",
          audienceExecutive: "الإدارات التنفيذية",
          audienceCompanies: "الشركات",
          audienceGov: "الجهات الحكومية",
          audienceAssociations: "الجمعيات",

          challengesTitle: "التحديات التي تحلها محضر",
          challengesDes:
            "تُنهي محضر المشاكل اليومية في إدارة الاجتماعات ومحاضرها.",
          challenge1: "ضياع التوصيات بعد الاجتماعات",
          challenge2: "تأخر إعداد المحاضر",
          challenge3: "صعوبة متابعة المهام",
          challenge4: "الاعتماد اليدوي للمحاضر",
          challenge5: "تشتت الملفات بين البريد الإلكتروني وتطبيقات التواصل",
        },
        blogsPage: {
          blogDetail: "تفاصيل المدونة",
          latestArticles: "أحدث المقالات",
          articleDescription:
            "وجهات نظر متعمقة حول التكنولوجيا والتصميم والأعمال التجارية والحياة.",
          backToBlogs: "العودة إلى المدونة",
          blogNotFound: "المدونة غير موجودة",
          relatedArticles: "المقالات ذات الصلة",
          lastUpdated: "آخر تحديث",
          Created: "تم الإنشاء",
          readArticle: "اقرأ المقالة",
        },
        contact: {
          TitleContact: "هل ترغب في تطوير اجتماعات شركتك؟",
          SubTitleContact:
            "فريقنا جاهز للإجابة عن جميع استفساراتك ومساعدتك في اختيار الحل المناسب.",
          getInTouch: "هل ترغب في تطوير اجتماعات شركتك؟",
          letsChat: "هل لديك استفسار؟ فريقنا مستعد للإجابة.",
          fullName: "الاسم الكامل",
          firstName: "الاسم الأول",
          lastName: "الاسم الأخير",
          emailAdd: "عنوان البريد الإلكتروني",
          message: "الرسالة",
          leaveUsMessage: "اترك لنا رسالة",
          sendMessage: "إرسال الرسالة",
          email: "البريد الإلكتروني",
          phone: "الهاتف",
          address: "العنوان",
          addressValue: "الرياض، المملكة العربية السعودية",
          faqTitle: "الأسئلة الشائعة",
          faqSubTitle: "إجابات على أكثر الأسئلة شيوعًا حول منصة محضر",

          faq1Question: "هل تدعم المنصة اللغة العربية؟",
          faq1Answer:
            "نعم، تدعم المنصة اللغة العربية وتستخدم الذكاء الاصطناعي لتحويل الاجتماعات إلى محاضر دقيقة وواضحة.",

          faq2Question: "هل يمكن تعديل المحضر بعد إنشائه؟",
          faq2Answer:
            "نعم، يمكنك مراجعة المحضر وتعديله قبل اعتماده لضمان دقة جميع التفاصيل.",

          faq3Question: "هل تدعم الاجتماعات الحضورية والافتراضية؟",
          faq3Answer:
            "نعم، تدعم المنصة توثيق الاجتماعات سواء كانت حضورية أو افتراضية من خلال تسجيلها وتحويلها إلى محاضر احترافية.",

          faq4Question: "كيف يتم اعتماد المحاضر؟",
          faq4Answer:
            "يتم اعتماد المحاضر إلكترونيًا عبر Signit، مما يتيح لجميع الأطراف التوقيع بسرعة وأمان دون الحاجة إلى النسخ الورقية.",

          faq5Question: "هل البيانات آمنة ومشفرة؟",
          faq5Answer:
            "نعم، تُستضاف بياناتك داخل المملكة العربية السعودية، وتُحمى بأحدث تقنيات التشفير ومعايير الأمان، لضمان أعلى مستويات الخصوصية والامتثال وحماية المعلومات.",
        },
      },
      linkWorkSpace: {
        search: "دعوة عبر البريد الإلكتروني أو اسم المستخدم",
        sendInvitation: "إرسال الدعوة",
        invitationSent: "تم إرسال الدعوة",
      },
      next: "التالي",
      addMeetingAgenda: "أضف جدول أعمال الاجتماع",
      meetingAgenda: "أجندة الاجتماع",
      transcript: "نص",
      dialogue: "الحوار",
      keyPoints: "النقاط الرئيسية",
      highlights: "أبرز النقاط",
      chatHistory: "سجل المحادثات",
      overview: "ملخص",
      approvalStatus: "حالة الموافقة",
      signedBy: "موقعة",
      dateOfApproval: "تاريخ الموافقة",
      keyDecisions: "القرارات الرئيسية",
      followUpAction: "عناصر إجراء المتابعة",
      meetingMinutesApproval: "موافقة محضر الاجتماع",
      commentHighlights: "التعليق والمعالم البارزة",
      addTemplate: "إضافة قالب",
      addNewSection: "أضف قسمًا جديدًا",
      addAttachments: "إضافة المرفقات",
      previewDetails: "تفاصيل المعاينة",
      dateTime: "التاريخ والوقت",
      hostName: "اسم المضيف",
      noWorriesWillSend: "لا تقلق سنرسل لك الرمز لإعادة التعيين",
      forgetPassword: "هل نسيت كلمة السر؟",
      backToLogin: "العودة لتسجيل الدخول",
      printedOn: "مطبوعة على",
      host: "يستضيف",
      meetingSummaryPDF: "ملخص الاجتماع",
      dontForgetToRecord: "لا تنس تسجيل كل ثانية",
      enterYourEmail: "أدخل بريدك الإلكتروني",
      backToWebsite: "العودة إلى موقع الويب",
      createAnAccount: "إنشاء حساب",
      enterYourPassword: "أدخل كلمة المرور الخاصة بك",
      iAgreeToThe: "أوافق على",
      termsAndConditions: "الشروط والأحكام",
      privacyPolicy: "سياسة الخصوصية",
      createAccount: "إنشاء حساب",
      registrationComplete: "تم إكمال التسجيل",
      registrationThankYouMessage: "شكرًا لك على التسجيل في محضر!",
      continueToLogin: "الاستمرار إلى تسجيل الدخول",
      backToHome: "العودة إلى الصفحة الرئيسية",
      needHelp: "تحتاج مساعدة؟",
      contactSupport: "اتصل بالدعم",
      orRegisterWith: "أو سجل مع",
      rescheduleMeeting: "اجتماع إعادة جدولة",
      reschedule: "إعادة جدولة",
      cancelMeeting: "إلغاء الاجتماع",
      invitedMembers: "الأعضاء المدعوين",
      invited_users: "المستخدمين المدعويين",
      fileTypeNotSupported: "امتداد الملف {{fileName}} غير مدعوم",
      trialReminder:
        "تذكير: تنتهي فترة التجربة المجانية الخاصة بك في {{days}} أيام",
      upgradeFeature: "ترقية لفتح هذه الميزة",
      subscriptionExpiringSoon:
        "اشتراكك ينتهي خلال {{days}} يوم. جدد الآن لتجنب الانقطاع.",
      subscriptionExpired:
        "انتهى اشتراكك. يرجى التجديد لمواصلة استخدام المنصة.",
      forbiddenTitle: "الوصول مرفوض",
      forbiddenDescription: "ليس لديك صلاحية للوصول إلى هذه الصفحة حالياً.",
      noActiveSubscription:
        "اشتراكك غير نشط. يرجى تجديد الخطة لمواصلة استخدام ميزات محضر.",
      upgradeNow: "قم بالترقية الآن",
      upgradeMeetingCount: "ترقية لزيادة عدد الاجتماعات الخاصة بك",
      upgradeUsersCount: "ترقية لزيادة عدد المستخدمين لديك",
      upgradeAiGeneratedMinutes:
        "ترقية لزيادة عدد دقائق الاجتماعات التي يتم إنشاؤها بواسطة الذكاء الاصطناعي",
      upgradeAiMeetingReachedQuota:
        "لقد وصلت إلى الحصة الشهرية لاجتماعات الذكاء الاصطناعي. يرجى الترقية لمزيد من الاجتماعات التي يتم إنشاؤها بواسطة الذكاء الاصطناعي.",
      acceptanceNeeded: "مطلوب الموافقة",
      search: "بحث",
      startSearching: "ابدأ تجربتك المجانية البحث",
      multipleWorkspaces: "مساحات عمل متعددة",
      abstain: "غائب",
      yes: "نعم",
      no: "لا",
      beforeMeeting: "قبل الاجتماع",
      select: "اختيار",
      offline: "غير متصل",
      from: "من",
      more: "أكثر",
      accept: "قبول",
      ago: "منذ",
      join: "انضمام",
      joinMeeting: "انضم إلى الاجتماع",
      TheRunningMeetingIs: "الإجتماع الجاري الآن هو: {{name}}",
      due: "مستحق",
      availableShares: "المشاركات المتوفرة",
      aprove: "موافقة",
      approved: "تمت الموافقة",
      started: "تم البدء",
      ended: "تم الانتهاء",
      invitationTo: "دعوة لـ",
      accepted: "تم القبول",
      addParticipants: "إضافة مشاركين",
      add: "إضافة",
      addSection: "إضافة قسم",
      addSubsection: "إضافة قسم فرعي",
      addFile: "إضافة ملف",
      updateSubsection: "تحديث قسم فرعي",
      saveNewDate: "حفظ التاريخ الجديد ",
      agenda: "جدول الأعمال",
      required: "مطلوب",
      close: "إغلاق",
      create: "يخلق",
      logout: "تسجيل الخروج",
      resentcode: "إعادة إرسال الكود",
      invalidcode: "كود غير صالح",
      resetlinksuccess: "تم إرسال OTP عبر البريد الإلكتروني",
      loginsuccess: "تم تسجيل الدخول بنجاح",
      hello: "مرحبًا",
      members: "الأعضاء",
      workspace: "مساحة العمل",
      meetingAddress: "مطلوب عنوان الاجتماع",
      previousDay: "اليوم السابق",
      nextDay: "اليوم التالي",
      loadMore: "إظهار المزيد",
      delete: "حذف",
      editDescription: "تعديل الوصف",
      type: "النوع",
      category: "الفئة",
      public: "عام",
      private: "خاص",
      editMore: "تعديل",
      priority: "الأولوية",
      login: "تسجيل الدخول",
      reset: "إعادة تعيين",
      edit: "تعديل",
      update: "تحديث",
      end: "إنهاء",
      return: "عودة",
      forgotPassword: "هل نسيت كلمة المرور؟",
      googleConnect: "تسجيل الدخول باستخدام جوجل",
      syncGoogleCalendar: "مزامنة مع تقويم جوجل",
      seeSummary: "الاطلاع على الملخص",
      seeSummaryAndSign: "الاطلاع على الملخص والتوقيع",
      timestamp: "الطابع الزمني",
      mention: "إشارة",
      decision: "قرار",
      remove: "إزالة",
      activate: "تفعيل",
      recentActivity: "نشاط حديث",
      resetPassword: "إعادة تعيين كلمة المرور",
      password: "كلمة المرور",
      confirmPassword: "تأكيد كلمة المرور",
      save: "حفظ",
      draft: "مسودة",
      pending: "معلّق",
      seeDetails: "الاطلاع على التفاصيل",
      cancel: "إلغاء",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      origin: "المنشأ",
      wrong: "خطأ",
      replace: "استبدال",
      files: "الملفات",
      reject: "رفض",
      rejectReason: "سبب الرفض",
      shares: "المشاركات",
      voteWeight: "أهمية التصويت",
      location: "الموقع",
      privateMeeting: "اجتماع خاص",
      newMeeting: "اجتماع جديد",
      editMeeting: "تعديل الاجتماع ",
      clearFilters: "مسح عوامل التصفية",
      createPoll: "إنشاء استطلاع",
      createTask: "إنشاء مهمة جديدة",
      createWorkspace: "إنشاء مساحة عمل",
      scheduleMeeting: "جدولة اجتماع",
      scheduleNewMeeting: "جدولة اجتماع",
      scheduleMeetingLater: "الجدول لاحقًا",
      instantMeeting: "الاجتماع الفوري",
      createMeeting: "إنشاء اجتماع",
      updateMeeting: "تحديث الاجتماع",
      updateSummary: "تحديث الملخص",
      localMeeting: "اجتماع محلي",
      localTime: "الوقت المحلي",
      createDraft: "إنشاء مسودة",
      uploadDocument: "تحميل مستند",
      upload: "تحميل",
      onlyNumbers: "أرقام فقط",
      users: "المستخدمون",
      usersProfile: "الملف الشخصي للمستخدمين",
      usersFrom: "نموذج المستخدم",
      role: "الدور",
      editProfile: "تعديل الملف الشخصي",
      addAll: "إضافة الجميع",
      allRoles: "جميع الأدوار",
      addNewUser: "إضافة مستخدم جديد",
      editUser: "تحرير تفاصيل المستخدم",
      searchUser: "البدء في كتابة الاسم",
      noResults: "لا توجد نتائج",
      participant_other: "المشاركون",
      participant_one: "مشارك",
      guest_other: "الضيوف",
      guest_one: "زائر",
      fileError: "اسم الملف هذا موجود بالفعل",
      today: "اليوم",
      yesterday: "الأمس",
      older: "الأقدم",
      add_performers: "إضافة مؤدٍ",
      add_presenters: "إضافة مقدّم",
      addPresenter: "إضافة مقدّم",
      presenters: "المقدّمون",
      performers: "المؤدون",
      duration: "المدة",
      templateCreated: "تم إنشاء القالب بنجاح",
      templateUpdated: "تم تحديث القالب بنجاح",
      templateDeleted: "تم حذف القالب بنجاح",
      recordingStopped: "توقف التسجيل والنسخ الآلي",
      recordingStarted: "بدأ التسجيل والنسخ الآلي",
      AITranscirptDisabled: "تم تعطيل نص الذكاء الاصطناعي",
      AITranscirptEnable: "تمكين نص الذكاء الاصطناعي",
      invitiationTo: "دعوة لـ",
      details: "التفاصيل",
      description: "الوصف",
      addDescription: "إضافة وصف",
      userNotActive: "هذا المستخدم غير نشط الآن.",
      performingConditions: "شروط الأداء",
      workspacePresencePlaceholder: "إذا كنت تريد رفض الدعوة، يُرجى تقديم سبب",
      workspacePrenanceValidation: "مطلوب ذكر السبب",
      invitationDeclined: "تم رفض الدعوة",
      invitationAccepted: "تم قبول الدعوة",
      reviewer_other: "$t( {{numbers}} المراجعون, arabicToEasternArabic)",
      reviewer_one: "المراجع",
      poolsAndVotings: "عمليات التصويت",
      activeTasks: "المهام النشطة",
      pageingInfo: "إظهار {{from}} - {{to}} من {{total}}",
      viaEmail: "عبر البريد الإلكتروني",
      viaSms: "عبر الرسائل القصيرة",
      inactive: "غير نشط",
      quorum: "النصاب القانوني",
      vote_weight: "وزن التصويت",
      share: "يشارك",
      invitations: "الدعوات",
      dueDate: "التاريخ المقرر",
      onlyUnread: "غير المقروء فقط",
      signature: "إمضاء",
      currentLifecycle: "دورة الحياة الحالية",
      titleOfMotion: "عنوان الطلب",
      titleOfAgenda: "عنوان جدول الأعمال",
      permissionsChanged: "تغيرت أذوناتك",
      participants: "مشاركين",
      talkTime: "وقت التحدث",
      leave: "يترك",
      participant: "مشارك",
      maxFileSizeIs: "يجب أن يكون أقصى حجم للمرفق هو {size} ميجابايت",
      invitetoSignMeetingSummary: "دعوة لتوقيع ملخص الاجتماع",
      lexicalEditor: {
        addComment: "أضف التعليق",
        editComment: "تحرير التعليق",
        yourComment: "تعليقك",
        selectTextToComment: "حدد النص الذي تريد التعليق عليه",
      },
      newMeetingRoles: {
        participants: "$t({{numbers}} المشاركون, arabicToEasternArabic)",
        guests: "$t({{numbers}} الضيوف, arabicToEasternArabic)",
        reviewers: "$t({{numbers}} المراجعون, arabicToEasternArabic)",
      },
      quorumTypes: {
        majority_number: "أغلبية العدد بناءً على الشركة",
        majority_shares: "أغلبية الأسهم بناءً على الشركة",
        majority_number_company: "أغلبية العدد بناءً على الشركة",
        majority_shares_company: "أغلبية الأسهم بناءً على الشركة",
        majority_mixed: "أغلبية العدد والأسهم بناءً على الشركة",
        cumulative_voting: "التصويت التراكمي",
        majority_number_workspace: "أغلبية العدد بناءً على مساحة العمل",
        majority_shares_workspace: "أغلبية العدد بناءً على مساحة العمل",
      },
      errorPage: {
        title: "الصفحة غير موجودة ",
        subtitle: "هذه الصفحة غير موجودة أو تمت إزالتها.",
        backButton: "العودة إلى الصفحة الرئيسية ",
      },
      settingPage: {
        meetingTimeLimit: "الحد الزمني للاجتماع ٤٥ دقيقة",
        meetingTimeLimitU: "الحد الزمني للاجتماع: غير محدود بالدقائق",
        meetingTimeLimit20: "زمن الاجتماع: ٢٠ ساعة",

        meetingRecording: "تسجيل الاجتماعات",
        aiPoweredMinutesDrafting180:
          "الذكاء الاصطناعي لصياغة المحضر: ١٨٠ دقيقة",
        calendarForScheduledMeetings: "تقويم للاجتماعات المجدولة",
        cloudStorage5GB: " التخزين السحابي: ٥ جيجابايت",
        attachDocumentsToMinutes: "إرفاق المستندات في المحاضر",
        advancedSecurityAndDataEncryption:
          "أمان متقدم وتشفير للبيانات والمعلومات",
        liveChatSupport: "الدعم عبر الدردشة الفورية",

        meetingTimeLimit30: "الحد الزمني للاجتماع ٣٠ ساعة",
        meetingTimeLimit50: "الحد الزمني للاجتماع ٥٠ ساعة",
        viewDownloadMeetingMinutes: "عرض وتحميل محضر الاجتماع",
        dashboardForUpcomingMeetings: "لوحة الاجتماعات القادمة",
        scheduleMeetings: "جدولة الاجتماعات",
        createAgenda: "إنشاء جدول الأعمال",
        addParticipants3: "إضافة المشاركين:٣",
        addParticipants12: "إضافة المشاركين: ١٠٠",
        allFeatureOfFreePlan: "جميع مميزات الباقة المجانية بالإضافة إلى:",
        allFeatureOfFirstPlan: "جميع ميزات الباقة محضر بلس بالإضافة إلى:",
        allFeatureOfThirdPlan: "جميع ميزات الباقة محضر برو بالإضافة إلى:",
        addParticipants300: "إضافة المشاركين: حتى ٣٠٠",
        addParticipants50: "إضافة المشاركين: حتى ٥٠",
        fullMeetingSummaryFlow: "تدفق ملخص الاجتماع الكامل",
        mailNotifications: "إشعارات البريد الإلكتروني",
        userlimit3: "الحد الأقصى للمستخدمين: حتى  ٣",
        userlimit100: "الحد الأقصى للمستخدمين: حتى ١٠٠",
        userlimit300: "الحد الأقصى للمستخدمين: حتى ٣٠٠",
        userlimit50: "الحد الأقصى للمستخدمين: حتى ٥٠",
        recordedMeeting: "اجتماع مسجل",
        meetingLimit3: "الحد الأقصى للاجتماعات: حتى ٣",
        meetingLimitU: "الاجتماعات المرئية: غير محدود",
        eSignatureMinutes:
          "التوقيع الإلكتروني لمحضر الاجتماع (الخدمة المدفوعة) ",
        videoMeeting45Each: "الاجتماعات المرئية [مدة ٤٥ د]: ٣",
        signatureAtAdditionalCost: "التوقيع بتكلفة اضافية",
        eSignature: "التوقيع الإلكتروني:",
        notifications: "الإشعارات",
        createDepartments: "إنشاء الأقسام (مساحات العمل)",
        aiMeetingPlan: "دقيقة اجتماع الذكاء الاصطناعي:",
        aiMeeting6: "محضر الاجتماع باستخدام الذكاء الاصطناعي: حتى ٠ دقائق",
        aiMeeting180: "محضر الاجتماع باستخدام الذكاء الاصطناعي: حتى ١٨٠ دقيقة",
        aiMeeting400: "محضر الاجتماع باستخدام الذكاء الاصطناعي: حتى ٤٠٠ دقيقة",
        aiMeeting800: "محضر الاجتماع باستخدام الذكاء الاصطناعي: حتى ٨٠٠ دقيقة",
        aiMeeting:
          "اجتماعات إضافية باستخدام الذكاء الاصطناعي (الخدمة المدفوعة)",
        publicURL: "مشاركة رابط الاجتماع",
        instantMeetingOnly: "محضر الاجتماع الفوري",
        settings: "إعدادات",
        personalInformation: "معلومات شخصية",
        accountSecurity: "أمان الحساب",
        departments: "الأقسام",
        subscriptionAndBilling: "الاشتراك والفواتير",
        roleManagement: "إدارة الأدوار",
        chat: "محادثة",
        templateManagement: "إدارة القالب",
        basicDetails: "التفاصيل الأساسية",
        security:
          "أمان قياسي مع تشفير البيانات للاجتماعات والمحادثات والمكالمات والملفات",
        currentPassword: "كلمة المرور الحالية",
        addNewPassword: "أضف كلمة مرور جديدة",
        confirmNewPassword: "تأكيد كلمة مرور جديدة",
        ChooseYourRightPlan: "اختر خطتك المناسبة!",
        youHave: "لديك",
        permission: "إذن",
        createMeetings: "إنشاء اجتماعات",
        joinMeetings: "انضم إلى الاجتماعات",
        recordings: "التسجيلات",
        tryNow: "حاول الآن",
        subscribeNow: "اشترك الآن",
        startForFree: "ابدأ تجربتك المجانية مجانًا",
        tryTeam: "جرّبها لفريقك",
        startProfessional: "ابدأ تجربتك المجانية باحتراف",
        requestCustomPlan: "اطلب عرضًا مخصصًا",
        subscribed: "مشترك",
        activated: "فعال",
        mostPopular: "الأكثر شعبية",
        meetingAI: "لقاء الذكاء الاصطناعي",
        userName: "اسم المستخدم",
        email: "بريد إلكتروني",
        currentRole: "الدور الحالي",
        addedOn: "تمت إضافة على",
        admins: "مسؤولون",
        members: "أعضاء",
        viewers: "المشاهدين",
        newTemplate: "قالب جديد",
        calendar: "تقويم",
        storage: "التخزين السحابي - ٥ جيجابايت",
        freePlan: "الباقة المجانية",
        mahdarPlus: "باقة محضر بلس",
        mahdarPro: "باقة محضر برو",
        mahdarMax: "محضر ماكس ( الباقة الشاملة )",
        sar: "ريال سعودي",

        upcomingMeetingDashboard: "لوحة الاجتماعات القادمة",
        meetingDuration: "زمن الاجتماع: ٢٠ ساعة",
        aiPoweredMinutesDrafting: "الذكاء الاصطناعي لصياغة المحضر: ٤٠٠ دقيقة",
        meetingScheduling: "جدولة الاجتماعات",
        customWorkspaces: "مساحات العمل المخصصة",
        certifiedElectronicSignature:
          "التوقيع الإلكتروني المعتمد (الخدمة المدفوعة)",
        textChatDuringVideoMeetings: "المحادثة النصية في الاجتماعات المرئية",

        // 4th plan
        addParticipants: "إضافة المشاركين: ٣٠٠",
        meetingDuration4thPlan: "زمن الاجتماع: ٥٠ ساعة",
        aiPoweredMinutesDrafting4thPlan:
          "الذكاء الاصطناعي لصياغة المحضر: ٨٠٠ دقيقة",
        meetingMinutesTemplates: "قوالب نمذجة محاضر الاجتماعات",
        directCallSupport: "الدعم بالاتصال المباشر خلال ساعات العمل",
        customizedOnboardingTraining: "التدريب المخصص عند التفعيل",
        upgradePlan: "ترقية الباقة",
      },
      linkingWorkspaces: {
        openModalText: "ربط مساحات عمل أخرى",
        modalTitle: "اختيار مساحة العمل لربطها",
        modalPlaceholder: "نوع مساحة العمل ",
        modalValidation: "برجاء اختيار مساحة عمل ",
        modalApprove: "ارسال رابط الطلب ",
        unlinkNow: "إزالة الربط الان",
        requested: "إلزامي",
        rejected: "مرفوض",
        linked: "مرتبط",
        by: "بواسطة",
        invitationText: "يريد توصيل مساحة العمل هذه بـ",
      },
      taskPriority: {
        low: "منخفض",
        normal: "عادي",
        important: "عالي",
        critical: "حساس",
      },
      recordedMettings: {
        registration: "انقر هنا للتسجيل",
        join: "ينضم",
      },
      milestoneForm: {
        milestoneCreated: "تم إنشاء مهمة",
        milestoneMovedToWorkspace: "تمت إحالة الهمة لمساحة العمل ",
        moveToWorkspace: "النقل لمساحة العمل",
      },
      meetingOperation: {
        text: "نص",
        voting: "التصويت",
        task: "مهمة مخصصة",
        votingResults: "نتائج التصويت ",
        taskResults: "نتائج المهمة ",
      },
      createWorkspacePopup: {
        workspaceName: "اسم مساحة العمل",
        workspaceType: "نوع مساحة العمل",
        visibility: "الرؤية",
        dueDate: "تاريخ الاستحقاق",
        invitedMembers: "الأعضاء المدعوون",
      },
      joinMeetingPage: {
        transScriptRecordingStop: "توقف النص",
        transScriptRecordingStart: "نص",
        meetingTitle: "عنوان الاجتماع",
        dateTime: "التاريخ والوقت",
        duration: "مدة",
        meetingType: "نوع الاجتماع",
        workspace: "مساحة العمل",
        status: "حالة",
        hostName: "اسم المضيف",
        participants: "مشاركون",
        Copied: "منقول",
        copyLink: "نسخ الرابط",
        sureEndMeeting: "هل أنت متأكد أنك تريد إنهاء هذا الاجتماع؟",
        sureLeaveMeeting: "هل أنت متأكد أنك ستغادر الإجتماع؟",
        endMeeting: "نهاية الاجتماع",
        leaveMeeting: "مغادرة الاجتماع",
        connectingMoment: "الاتصال باجتماعك، مجرد لحظة!",
        meetingAgenda: "جدول أعمال الاجتماع",
        meetingMinutes: "محضر الاجتماع",
        chat: "محادثة",
        Stop: "نص & سِجِلّ قف",
        Record: "نص & سِجِلّ",
      },
      taskStatus: {
        to_do: "المهام",
        in_progress: "قيد التنفيذ",
        rejected: "مرفوض",
        done: "تم",
      },
      language: {
        button: "اللغة",
        hello: "مرحبًا {{name}}",
        systemLanguage: "لغة النظام",
        english: "English",
        arabic: "العربية",
      },
      activity: {
        recentActivity: "نشاط حديث",
        days: {
          today: "اليوم، {{date}}",
          yesterday: "الأمس، {{date}}",
        },
      },
      textCreator: {
        placeholders: {
          title: "إدخال عنوان نصي",
          description: "إدخال وصف نصي",
        },
      },
      filters: {
        allTasks: "كل المهام",
        allVotings: "كل التصويتات",
        allMeetings: "كل الاجتماعات",
        assignedToMe: "تم التعيين إليّ",
        allWorkspaces: "جميع مساحات العمل",
        myWorkspaces: "مساحات العمل الخاصة بي",
        dueDate: {
          today: "مستحق اليوم",
          tomorrow: "مستحق غدًا",
          thisWeek: "مستحق في الأسبوع الحالي",
          thisMonth: "مستحق في الشهر الحالي",
          overdue: "متأخر عن الاستحقاق",
        },
      },
      setPassword: {
        setNew: "تعيين كلمة مرور جديدة",
        passwordSet: "إنشاء كلمة مرور جديدة",
        submit: "تعيين واحدة جديدة",
        mustBe8Characters: "يجب أن يكون 8 أحرف",
      },
      votingSummary: {
        approved: "اعتمد ملخص التصويت",
        signed: "والتوقيع",
        votingType: "نوع التصويت",
        voting: "التصويت ",
        results: "النتائج",
        approvalRequestedAction: "تم طلب الموافقة على ملخص التصويت",
        approvedAction: "تم اعتماد ملخص التصويت ",
        disapprovedAction: "تم رفض ملخص التصويت",
        secret: "سري ",
        vote: "تصويت ",
        votes: "الأصوات",
        downloadedAction: "تم تحميل ملخص التصويت ",
        sentToSignAction: "ارسال ملخص التصويت للتوقيع ",
        signedAction: "توقيع قرار وملخص التصويته ورفعه",
        uploadTitle: "توقيع محضر الاجتماع ",
        uploadText: "تحميل المحضر وتوقيعه ورفعه النسخة الموقعة ",
        addConclusion: "إضافة قسم",
        editConclusion: "التعديل على الخاتمة ",
        conclusionUpdated: "تحديث نتائج التصويت الملخص",
        conclusions: "الخاتمة ",
        editNote: "تعديل الملاحظة",
        creator: "المنشئ",
      },
      voting: {
        heedMyVote: "توجيه صوتي",
        votingOwner: "منشئ التصويت",
        sharesUsed: "الاسهم المستخدمة",
        participants: "المشاركون",
        voteSecrecy: "سرية التصويت",
        quorumType: "نوع النصاب القانوني",
        givePower: "منح دورك لـ {{name}}",
        requestVote: "طلب {{name}} للتصويت",
        votingType: "نوع التصويت",
        optionsToChoose: " عدد الخيارات المراد تحديدها",
        optionsToWin: "عدد الخيارات المراد الفوز بها",
        saveVoting: "حفظ التصويت",
        voting: "التصويت",
        addElement: "إضافة عنصر",
        users: "المستخدمون",
        addUser: "إضافة مستخدم",
        label: {
          dateStart: "تاريخ بدء التصويت",
          dateEnd: "تاريخ انتهاء التصويت",
          votingResult: "نتائج التصويت",
        },
        placeholders: {
          name: "إدخال عنوان التصويت ",
          option: "إدخال خيار التصويت",
          note: "ستكون المعلومات المضافة في هذا الحقل مرئية كملخص لنتيجة التصويت",
        },
        votingRoles: {
          voting_owner: "المالك",
          voting_voter: "المصوّت",
          voting_commentator: "المعلّق",
          voting_viewer: "العارض",
          voting_eliminated: "تم الإقصاء",
        },
        actionMessages: {
          created: "تم إنشاء تصويت",
          updated: "تم تحديث التصويت",
          deleted: "تم حذف التصويت",
          statusUpdated: "تم تحديث الحالة",
          noteSaved: "تم حفظ الملاحظات",
          voteTransferred: "تم تحويل  حق التصويت",
          remindNotificationSent: "تم إرسال تذكير",
        },
      },
      profile: {
        title: "الملف الشخصي",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        memberOf: "عضو في ",
        memberOfWorkspaces: "مساحات العمل",
        location: "الموقع",
      },
      rolesSelect: {
        general: "عام",
        votings: "التصويتات",
        meetings: "الاجتماعات",
      },
      twoStepAuth: {
        title: "المصادقة في خطوتين ",
        info: "إدخال كود التحقق قمنا بإرساله إلى",
      },
      companyForm: {
        contactInformations: "معلومات الاتصال",
        sharesTitle: "الاسهم",
      },
      roles: {
        secretary: "سكرتير",
        manager: "مدير تنفيذي",
        executive_mng: "مدير تنفيذي",
        member: "عضو",
        chief: "الرئيس التنفيذي",
        admin: "مشرف إداري",
        board_director: "مدير مجلس الإدارة",
        boardOfDirectors: "مجلس الإدارة",
        shareholder: "المساهم",
        executiveManagement: "الإدارة التنفيذية",
        independent: "عضو مجلس إدارة مستقل",
        executive: "عضو مجلس إدارة تنفيذي مع اللجان",
        auditor: "مدقق",
        regularGeneralAssembly: "الجمعية العمومية العادية",
        extraordinaryGeneralAssembly: "الجمعية العمومية غير العادية",
        guest: "الضيف",
        waiting_for_account: "بانتظار حساب",
        meeting_organizer: "منظم اجتماعات",
        meeting_shareholder: "المساهم",
        meeting_board_of_directors: "مجلس الإدارة",
        meeting_executive_management: "الإدارة التنفيذية",
        meeting_independent_board_member: "عضو مجلس إدارة مستقل",
        meeting_executive_brd_mbr_com: "عضو مجلس إدارة تنفيذي مع اللجان",
        meeting_auditor: "مدقق",
        meeting_regular_general_assembly: "الجمعية العمومية العادية",
        meeting_extraordinary_general_assembly: "الجمعية العمومية غير العادية",
        voting_owner: "منشئ التصويت",
        voting_voter: "المصوّت",
        voting_commentator: "المعلّق",
        voting_viewer: "العارض",
        voting_eliminated: "تم الإقصاء",
        meeting_admin: "مسؤول الاجتماع",
        meeting_owner: "مالك الاجتماع",
        meeting_secretary: "سكرتير الاجتماع",
        meeting_attendee: "حاضر الاجتماع",
        meeting_guest: "ضيف الاجتماع",
        meeting_viewer: "عارض الاجتماع",
        some_custom_role_mm: "بعض الأدوار المخصصة MM",
      },
      notification: {
        remind: "قم بتذكيري خلال 10 دقائق",
        meeting: {
          invitation: {
            inviting: "دعوة شخص: {{name}}",
            date: "التاريخ: {{date}}",
            form: "النموذج: ",
          },
        },
      },
      meetingRoles: {
        secretary: "سكرتير",
        organiser: "المنظم",
        guest: "الضيف",
      },
      userTypes: {
        internal: "داخلي",
        external: "خارجي",
      },
      menu: {
        home: "المنزل",
        workspaces: "مساحات العمل",
        calendar: "التقويم",
        messages: "الرسائل",
        documents: "المستندات",
        tasks: "المهام",
        votings: "التصويتات",
        pollsAndVotings: "الاستطلاعات والتصويتات",
        styleguide: "دليل الأسلوب",
        minimize: "تصغير القائمة",
        settings: "الإعدادات",
        meetings: "اجتماعات",
        meetings_min: "محضر الاجتماع",
        dashboard: "لوحة القيادة",
        users: "المستخدمون",
      },
      dashboards: {
        goodMorning: "صباح الخير",
        quickActions: "إجراءات سريعة",
        pendingActions: "إجراءات معلّقة",
        newRequests: "طلبات جديدة",
        comingUpNext: "التالي",
        actionItems: "خطوات العمل",
        activityFromWorkspaces: "نشاط من مساحات العمل",
        workspacesUpdates: "تحديثات مساحات العمل",
        urgent: "مهمة عاجلة:",
        youHave: "لديك",
        meetingsToday: "اجتماعات اليوم دعونا نحدد موعدًا للاجتماع",
        scheduleMeeting: "جدولة اجتماع",
        upcomingMeetings: "الاجتماعات القادمة",
        ViewAllmeetings: "عرض كافة الاجتماعات",
        joinNow: "انضم الآن",
        meetingUrl: "ألصق عنوان URL لاجتماعك هنا",
      },
      registerForm: {
        fullName: "الاسم بالكامل",
        role: "الدور",
        userType: "نوع المستخدم",
        addUser: "إضافة مستخدم",
      },
      createMeetingForm: {
        choosePerformersFirst: "اضف أولًا المسؤولين ومن ثم عارضين البند ",
        chooseVotingBefore: "اختر التصويت قبل الاجتماع ",
        chooseTaskBefore: "اختر المهمة قبل الاجتماع ",
        resultsOfTask: "نتائج المهمة قبل الاجتماع ",
        resultOfVoting: "نتائج التصويت قبل الاجتماع ",
        typeTaskName: "نوع المهمة ",
        typeVotingName: "نوع التصويت",
        subsectionDuration: "المدة الزمنية ",
        updateSubsection: "تحديث القسم ",
        addSelected: "اضافة الاختيار ",
        guestModal: "دعوة عضو خارجي",
        guestModalAdditionalText:
          "تحتاج إلى حفظ الاجتماع ، حتى تقوم بدعوة عضو خارجي.",
        meetingDeleted: "تم حذف الاجتماع",
        deleteConfirmation: "هل تريد بالتأكيد حذف {{entity}}؟",
        majorityOfShares: "أغلبية المشاركات",
        majorityOfNumber: "أغلبية العدد",
        majorityOfNumberAndShares: "أغلبية العدد والمشاركات",
        meetingCreatorTitle: "مُنشئ الاجتماع",
        titleRequired: "مطلوب إدخال العنوان ",
        enterTitle: "إدخال عنوان الاجتماع",
        enterDescription: "أدخل وصفًا اختياريًا للاجتماع",
        enterTranscriptSummary: "أدخل ملخص النص",
        enterSummaryConclusion: "أدخل خاتمة الملخص",
        enterMeetingAddress: "أدخل عنوان الاجتماع",
        frequencyDaysRequired: "حدد أيامًا للتكرار",
        meetingCreated: "تم إنشاء اجتماع",
        meetingUpdated: "تم تحديث الاجتماع",
        workspace: "مساحة العمل",
        quorumType: "نوع النصاب القانوني",
        enterTitlePlaceholder: "إدخال العنوان",
        sectionTitleRequired: "مطلوب إدخال عنوان القسم ",
        titleLengthErrorMax: "العنوان طويل جدًا. الحد الأقصى 100 حرف",
        titleLengthErrorMin: "العنوان قصير جدًا. الحد الأدنى حرف واحد",
        sectionDeleteConfirmation: "هل تريد بالتأكيد حذف القسم؟",
        updated: "تم التحديث:",
        secondsAgo: "منذ {{seconds}} ثوانٍ",
        minutesAgo: "منذ {{seconds}} من الدقائق",
        updateNow: "التحديث الآن",
        saveNow: "احفظ الان",
        peopleInMeeting: "الناس في الاجتماع",
        participantList: {
          removeParticipant: "إزالة المشارِك",
          removeUserModalTitle: "إزالة المشاركين",
          removeUserModalHeader:
            "You're about to remove {{name}} from the meeting.",
          removeUserModalSectionText: "This user is currently attending:",
          removeUserModalSubsectionText: "This user is also participating in:",
          confirmationMessage:
            "If you remove the user, they will be removed from the agenda section(s) but will not be removed from any assigned tasks or votes. You will need to remove them manually from the assigned events.",
          ok: "OK",
          cancel: "Cancel",
          genericConfirmationMessage:
            "هل أنت متأكد من إزالة {{name}} من الاجتماع؟",
          postPoneConfirmationMessage: "هل أنت متأكد أنك تريد",
          postpone: "تأجيل",
          theMeeting: "الاجتماع؟",
          describereason: "وضح السبب",
          reschedule: "إعادة الجدولة",
        },
        selectCalculationMethod: "اختر طريقة الحساب",
        scheduleMeeting: "جدولة اجتماع",
        addTemplate: "إضافة قالب",
        meetingTitle: "عنوان الاجتماع",
        date: "التاريخ والوقت",
        duration: "المدة",
        meetingType: "نوع الاجتماع",
        addMembers: "إضافة أعضاء",
        archiveConfirmation:
          "هل أنت متأكد أنك تريد أرشفة هذا الاجتماع {{entity}}؟",
      },
      archive: "أرشيف",
      viewMeeting: {
        noAccessSection: "ليس لديك حق الوصول إلى هذا القسم",
        agenda: {
          lastEdited: "تم آخر تعديل بواسطة {{name}}",
        },
      },
      meetingTypes: {
        by_presence: "بالحضور",
        remote: "عن بُعد",
      },
      meetingStatus: {
        Draft: "مسودة",
        PendingApproval: "في انتظار الموافقة",
        PendingReview: "في انتظار المراجعة",
        Approved: "معتمد",
        Started: "بدأ",
        Ended: "انتهى",
        PendingSummaryGenerate: "في انتظار توليد الملخص",
        PendingSummarySign: "في انتظار توقيع الملخص",
        SummarySigned: "تم توقيع الملخص",
        InvalidMeetingStatus: "حالة اجتماع غير صالحة",
      },
      participantStatus: {
        present: "حاضر",
        absent: "غائب",
      },
      meetingMessages: {
        remindMeIn: "قم بتذكيري خلال {{min}} من الدقائق",
        startingInMinutes_one: "يبدأ خلال دقيقة واحدة",
        startingInMinutes: "يبدأ خلال",
        years: "سنين",
        months: "شهور",
        days: "أيام",
        hours: "ساعات",
        minutes: "دقائق",
        sentToApprova: "تم إرسال الاجتماع للموافقة",
        startReview: "تم بدء مراجعة الاجتماع",
        approve: "تمت الموافقة على الاجتماع",
        disapprove: "تم رفض الاجتماع",
        acceptPresence: "تم قبول الحضور ",
        rejectPresence: "تم رفض الحضور ",
        successNextSection: "القسم التالي",
        successPreviousSection: "السابق",
        successSectionMeetingMinutes: "تم حفظ محضر الاجتماع",
        meetingPostponedAction: "تم تأجيل الاجتماع",
        sentForApproval: "تم تقديم الطلب للموافقة عليه",
      },
      meetingAction: {
        approvalSend: "إرسال المسودة للموافقة",
        approval: "الموافقة",
        disapproval: "الرفض",
        startReview: "بدء المراجعة",
      },
      globalSearchActions: {
        search: "يبحث",
        all: "الجميع",
        Users: "المستخدمين",
        Meeting: "مقابلة",
      },
      meetingLabels: {
        reason: "السبب",
        rejectReason: "سبب الرفض:",
        disapprovalTitle: "رفض الاجتماع: ",
        rejectInvitationTitle: "رفض دعوة الاجتماع: ",
      },
      userRolesSettings: {
        protectedRoleError: "لا يمكنك حذف هذا الدور",
        assignedRoleError: "لا يمكنك حذف دور معين للمستخدم",
        protectedRole: "لا يمكنك حذف هذا الدور",
        requiredPermissions: "الأذونات المطلوبة",
        rolesPageTitle: "الأدوار والأذونات",
        searchPlaceholder: "البدء في كتابة اسم الإذن",
        newRoleAdded: "تمت إضافة دور جديد",
        roleName: "اسم الدور",
        roleDeleted: "تم حذف الدور",
        roleModalDelete: "هل تريد بالتأكيد حذف الدور؟",
        roleNameMaxLength: "الحد الأقصى 50 حرفًا",
        roleDescriptionModalTitle: "تعديل وصف الدور",
        roleUpdated: "تم تحديث الدور",
      },
      userEditForm: {
        sharesTitle: "المشاركات",
        personalInformation: "معلومات شخصية",
        sharesToBig: "يجب أن يكون أقل من",
        totalShares: "إجمالي عدد الأسهم",
        sharesToBigMore:
          "إذا كنت ترغب في إضافة مزيد من المشاركات إلى هذا المستخدم، قم أولاً بتغيير النسبة المئوية للمشاركات لمستخدم آخر وفقًا لذلك",
        sharesToSmall: "يجب أن تكون أكبر من أو تساوي 0",
        sharesInCompany: "عدد الأسهم في الشركة",
        quorumInNumber: "عدد النصاب القانوني",
        contactInformations: "معلومات الاتصال",
        emailAddress: "عنوان البريد الإلكتروني:",
        phoneNumber: "رقم الهاتف",
        location: "الموقع",
        country: "الدولة",
        roleAndPower: "الدور والصلاحية خلال الاجتماعات",
        save: "حفظ التغييرات",
        _2fa: "عامل المصادقة الثاني",
        workspaceMembership: "الأعضاء في مساحات العمل ",
        showUserWorkspaces: "عرض أعضاء مساحة العمل ",
        votingWeight: "وزن التصويت",
        govId: "هوية الحكومة",
        language: "لغة",
      },
      createWorkspaceForm: {
        deleteConformation: "هل تريد بالتأكيد حذف مساحة العمل؟",
        usersAdded: "تمت دعوة المستخدمين إلى مساحة العمل",
        nameRequired: "مطلوب إدخال الاسم",
        enterName: "مطلوب إدخال اسم مساحة العمل",
        description: "وصف مساحة العمل (اختياري)",
        startTime: "بدءًا من",
        endTime: "إلى",
        createWorkspace: "إنشاء مساحة عمل",
        editWorkspace: "تحرير مساحة العمل",
        newWorkspace: "مساحة عمل جديدة",
        viewDetailsCreateWorkspace: "عرض التفاصيل وإنشاء مساحة عمل",
        members: "$t(الأعضاء {{numbers}} , arabicToEasternArabic)",
        addMember: "إضافة عضو",
        workspaceCreated: "تم إنشاء مساحة عمل",
        workspaceUpdated: "تم تحديث مساحة العمل",
        workspaceDeleted: "تم حذف مساحة العمل",
        updateWorkspace: "تحديث مساحة العمل",
        photoText: "صورة مساحة العمل",
        nameTooLong: "الاسم طويل جدًا. الحد الأقصى 50 حرفًا",
        descriptionTooLong: "الوصف طويل جدًا. الحد الأقصى 200 حرف",
        endDateRequired: "مطلوب إدخال تاريخ الانتهاء ",
        userDeleted: "تم حذف المستخدم",
        workspace: {
          named: "مساحة العمل: {{name}}",
          unnamed: "مساحة عمل أخرى",
        },
      },
      addGuest: {
        title: "إضافة ضيف",
        submit: "إضافة ضيف",
        addedGuestError: "تمت إضافة الضيف بالفعل",
        labels: {
          name: "الاسم",
          email: "عنوان البريد الإلكتروني:",
          phone: "رقم الهاتف",
          invitationText: "نص الدعوة",
        },
        placeholders: {
          name: "إدخال الاسم",
          email: "إدخال عنوان البريد الإلكتروني",
          phone: "إدخال رقم الهاتف",
          invitationText: "إدخال نص الدعوة",
        },
      },
      workspaces: {
        lifeCycle: "دورة الحياة",
        seeArchive: "الاطلاع على الأرشيف",
        workspace: "مساحة العمل",
        createWorkspace: "إنشاء مساحة عمل",
        memberOf:
          "$t(أنت حاليًا عضو في {{count}} من مساحات العمل, arabicToEasternArabic)",
        meetings: "الاجتماعات",
        addMeeting: "إضافة اجتماع ",
        noMeetingRecords: "لا توجد بيانات اجتماعات متاحة",
      },
      notifications: {
        title: "الإشعارات",
        noData: "ليس لديك إشعارات جديدة",
        markAllRead: "تمييز الجميع كمقروء",
        markAsRead: "تمييز كمقروء",
      },
      validation: {
        meetingStartTimeInPast: "وقت بدء الاجتماع في الماضي",
        titleEntityIsTooLong: "عنوان الأجندة طويل جدًا. 200 حرف كحد أقصى",
        taskRequirementIsRequired: "حقل العنوان إلزامي",
        taskRequirementTooShort:
          "المحتوى المدخل قصير جدًا، برجاء ادخل حرف على الأقل",
        taskRequirementTooLong: "المحتوى المدخل طويل جدًا، الحد الأقصى ٢٠٠ حرف",
        usersList: "مطلوب مستخدم واحد على الأقل",
        meetingAddressRequired: "مطلوب عنوان الاجتماع",
        titleEntityIsRequired: "مطلوب جدول أعمال العنوان",
        titleEntityIsTooShort:
          "جدول أعمال العنوان قصير جدًا. الحد الأدنى حرف واحد",
        titleEntityIsToShort:
          "جدول أعمال العنوان قصير جدًا. الحد الأدنى حرف واحد",
        elementIsRequired: "مطلوب إدخال خيار التصويت",
        elementIsTooLong: "خيار التصويت طويل جداً الحد الأقصى 200 حرف",
        elementIsTooShort: "خيار التصويت قصير جدًا. الحد الأدنى حرف واحد",
        phoneIsInvalid: "رقم الهاتف غير صالح",
        listIsRequired: "مطلوب بند واحد على الأقل",
        reviewerRequired: "مطلوب مراجع واحد على الأقل",
        participantRequired: "مطلوب مشارك واحد على الأقل",
        required: "مطلوب",
        durationMin: "ينبغي أن تكون المدة دقيقة واحدة على الأقل",
        emailIsInvalid: "البريد الإلكتروني غير صالح",
        titleIsRequired: "مطلوب إدخال العنوان ",
        titleIsTooLong: "العنوان طويل جدًا. الحد الأقصى 200 حرف",
        titleIsTooShort: "العنوان قصير جدًا. الحد الأدنى حرف واحد",
        descriptionIsRequired: "مطلوب إدخال الوصف",
        descriptionCurrentAndMaxLength:
          "الوصف يحتوي على {{current}}/{{max}} حرف",
        descriptionIsTooLong: "الوصف طويل جدًا. الحد الأقصى 200 حرف",
        descriptionIsTooShort: "الوصف قصير جدًا. الحد الأدنى حرف واحد",
        passwordIsRequired: "مطلوب إدخال كلمة المرور",
        passwordMinLength: "كلمة المرور قصيرة جدًا. الحد الأدنى 8 أحرف",
        passwordOneBigLetter:
          "يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل",
        passwordOneSmallLetter:
          "يجب أن تحتوي كلمة المرور على حرف صغير واحد على الأقل",
        passwordOneNumber: "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل",
        passwordRepeatNotMatch: "كلمات المرور غير متطابقة",
        votingOptionIsRequired: "مطلوب إدخال خيار التصويت",
        votingOptionIsTooLong: "خيار التصويت طويل جداً الحد الأقصى 100 حرف",
        votingUsers: "إضافة مستخدم واحد على الأقل",
        pastDate: "التاريخ قديم",
        listMinTwoAreRequired: "مطلوب بندان على الأقل",
        arrayMinLength: "على الأقل {{length}} عنصر",
        oneUserRequired: "مطلوب على الأقل مؤدٍ واحد",
        oneSpeakerRequired: "مطلوب على الأقل مقدّم واحد",
      },
      taskForm: {
        conditionItem_one: "$t(الشرط رقم {{count}},arabicToEasternArabic) ",
        conditionItem_two: "$t(الشرط رقم {{count}},arabicToEasternArabic) ",
        conditionItem_few: "$t(الشرط رقم {{count}},arabicToEasternArabic) ",
        conditionItem_other: "$t(الشرط رقم {{count}},arabicToEasternArabic)",
        usersTitle: "$t(المؤدون {{numbers}}, arabicToEasternArabic)",
        saveTask: "حفظ المهمة",
        dueDate: "تاريخ الأداء",
        performingConditions: "شروط الأداء",
        addElement: "إضافة عنصر",
        taskDescription: "وصف المهمة",
        newTask: "مهمة جديدة",
        taskCreated: "تم إنشاء مهمة",
        taskDeleted: "تم حذف المهمة بنجاح",
        conditions: "الشروط",
        beforeChoosePresenters: "قبل اختيار مقدمي العرض، اخترهم كمؤدين",
        requirementDeleted: "تم الحذف",
      },
      tasksPage: {
        task: "المهمة",
        tasks: "المهام",
        assignedTo: "تم التعيين إلى",
        createCustomTask: "إنشاء مهمة مخصصة",
        status: "الحالة",
        categories: {
          all: "جميع المهام الحالية",
          vote: "الاستبيانات / استطلاعات",
          surveys: "استطلاعات الرأي / استطلاعات الرأي",
          signatures: "التوقيعات",
          docApprovals: "الموافقات على المستندات",
          custom: "المهام المخصصة",
          done: "مكتمل",
          meeting: "الاجتماعات",
        },
      },
      calendarPage: {
        calendar: "التقويم",
        newMeeting: "اجتماع جديد",
        noMeetings: "لا توجد اجتماعات",
        clearDates: "مسح التواريخ",
        workspaceSelectPlaceholder: "مساحة العمل",
        seePast: "رؤية الاجتماعات المؤرشفة",
        seeFuture: "عرض الاجتماعات المقبلة",
      },
      taskPage: {
        due: "مستحق",
        priority: "الأولوية",
        markAsDone: 'وضع علامة "مكتمل"',
        markAsNotDone: 'وضع علامة "غير مكتمل"',
        done: "مكتمل",
        taskStatusChanged: "تم تغيير حالة المهمة",
        requirementStatusChanged: "تم تغيير حالة المتطلب ",
        changeStatus: "تم تغيير حالة المهمة",
        reason: "السبب",
        finishAllRequirements: "قم بإنهاء جميع الحقول الإلزامية أولاً",
        rejectTask: "رفض المهمة",
      },
      liveMeeting: {
        postponeText:
          "اختر تاريخًا جديدًا لهذا الاجتماع. الأجندة والمدعويين مكررين",
        postponeTitle: "تغيير موعد الاجتماع",
        pleaseWait: "يُرجى الانتظار...",
        noAccess: "لا يمكنك الوصول إلى هذا القسم من جدول الأعمال.",
        meetingNotStarted: "لم يبدأ الاجتماع بعد. انتظر حتى يتم البدء.......",
        participants: "المشاركون",
        participant: "مشارك",
        join: "انضم إلى الاجتماع الآن",
        onGoing: "جاري التنفيذ",
        quorumReached: "اكتمال النصاب",
        quorumNotReached: "لم يكتمل النصاب",
        changeMeetingDate: "تغيير موعد الاجتماع",
        meetingEnded: "انتهى الاجتماع",
        startMeeting: "بدء الاجتماع",
        waitMoment: "انتظر دقيقة",
        wantToJoin: "هل تريد الانضمام؟",
        wantToStart: "هل تريد أن تبدأ؟",
        agenda: "جدول الأعمال",
        meetingMinutes: "محضر الاجتماع",
        endThisSectionAndStartNext:
          "قم بإنهاء هذا القسم ثم ابدأ تجربتك المجانية في التالي ",
        backToPrevious: "العودة الى المقطع السابق",
        bottomBar: {
          more: "أكثر",
          agenda: "جدول الأعمال",
          record: "سجل",
          mute: "صامت",
          unmute: "غير صامت",
          stopVideo: "إيقاف الفيديو",
          startVideo: "بدء الفيديو",
          screenShare: "مشاركة الشاشة",
          endCall: "إنهاء المكالمة",
          leaveMeeting: "مغادرة الاجتماع",
          endMeeting: "إنهاء الاجتماع",
          voting: "التصويت",
          chat: "دردشة",
          participants: "المشاركون",
          stopScreenShare: "إيقاف المشاركة",
        },
      },
      votingsPage: {
        votingLiveRoomSwitch: "مع غرفة مباشرة",
        title: "التصويتات والاستطلاعات",
        create: "إنشاء",
        newVoting: "تصويت جديد ",
        before: "قبل",
        categories: {
          all: "جميع الاستطلاعات الحالية",
          votings: "التصويتات",
          questionnaires: "إستفتاءات",
        },
        votingSession: "جلسة التصويت",
        questionnary: "استفتاء",
        meeting: "الاجتماع",
        barAttending: "هل ستحضر؟",
        options: "خيارات التصويت",
        results: "نتائج التصويت",
      },
      liveVoting: {
        saveNote: "حفظ الملاحظة ",
        votingLive: "تصويت مباشر",
        voting: "التصويت",
        noVoting: "لا يوجد تصويت",
        noAvailableVotes: "ليس لديك أي أصوات متاحة أو تم استخدام أصواتك",
        sendAnswer: "إرسال الإجابة",
        startVoting: "بدء التصويت",
        endVoting: "إنهاء التصويت",
        abstain: "الامتناع عن التصويت",
        shares: "المشاركات",
        vote_zero: "$t({{count}} أصوات, arabicToEasternArabic)",
        vote_one: "$t({{count}} تصويت, arabicToEasternArabic)",
        vote_two: "$t({{count }} تصويتان , arabicToEasternArabic)",
        vote_few: "$t( {{count}} تصويتات, arabicToEasternArabic)",
        vote_other: "$t( {{count}} الأصوات,arabicToEasternArabic)",
        votingNotStarted: "لم يبدأ التصويت بعد. انتظر حتى يتم البدء.......",
        join: "انضم إلى التصويت الآن",
        votingEnded: "تم إنهاء التصويت",
        waitMoment: "انتظر دقيقة",
        people_zero: "$t({{count}} شخص , arabicToEasternArabic)",
        people_one: "$t({{count}} شخص , arabicToEasternArabic)",
        people_other: "{{count}} أشخاص",
        requestToVote: "طلب التصويت",
      },
      meetings: {
        calendar: "تقويم",
        recordings: "التسجيلات",
        meetings: "الاجتماعات",
        Upcoming: "الاجتماعات القادمة",
        ongoing: "الاجتماعات الجارية",
        ended: "الاجتماعات المنتهية",
        newMeeting: "اجتماع جديد",
        search: "يبحث",
        meetingsMinutes: "دقائق الاجتماعات",
        newest: "أحدث",
        oldest: "أقدم",
        downloadPDF: "تنزيل PDF",
        viewMinutes: "عرض الدقائق",
      },
      scheduleMeetingPopup: {
        scheduleMeeting: "جدولة اجتماع",
        meetingTitle: "عنوان الاجتماع",
        meetingDescription: "وصف الاجتماع",
        transcriptSummary: "ملخص النص",
        summaryConclusion: "ملخص الخاتمة",
        dateAndTime: "التاريخ والوقت",
        duration: "مدة",
        workspace: "مساحة العمل",
        meetingType: "نوع الاجتماع",
      },
      meetingSummary: {
        votingNotEnded: "التصويت لم ينتهي ",
        viewSummary: "عرض الملخص",
        attendances: "الحضور",
        agenda: "جدول الأعمال",
        minutesApprovedAction: "تمت الموافقة على محضر الاجتماع",
        minutesDisapprovedAction: "تم رفض محضر الاجتماع",
        minutesRequestedAction: "مطلوب الموافقة على محضر الاجتماع",
        minutesSentToSignAction: "تم إرسال محضر الاجتماع للتوقيع",
        minutesDownloadedAction: "تم تنزيل ملخص الاجتماع",
        inviteAcceptMeetingSummary: "دعوة لقبول ملخص الاجتماع",
        invitationSent: "تم إرسال الدعوة",
        invite: "يدعو",
        sendInvitation: "أرسل الدعوة",
        searchUsers: "بحث المستخدمين",
        noteEditedAction: "تم تعديل ملاحظات الاجتماع",
        plannedTime: "الوقت المخطط",
        meetingNotFound: "لم يتم العثور على الاجتماع ",
        sign: "توقيع",
        sendToSign: "الإرسال لوضع التوقيع",
        accept: "الموافقة على الملخص",
        reject: "رفض",
        suggestChanges: "اقتراح تغييرات",
        inviteToAcceptance: "دعوة للموافقة",
        sendToApproval: "إرسال إلى الموافقة",
        approveSummary: "الموافقة على الملخص",
        approved: "تمت الموافقة على ملخص الاجتماع",
        signed: "وتم التوقيع",
        presentUsers: "حضر الأشخاص المذكورين أدناه",
        absentUsers: "غاب الأشخاص المذكورين أدناه",
        hideDocument: "إخفاء مستند",
        showDocument: "إظهار المستند كاملاً",
        submissionTitle: "تقديم المحضر والموافقة عليه",
        minutesSubmited: "قدّم المحضر",
        minutesApproved: "وافق على المحضر",
        minutesRejected: "رفض المحضر",
        presenters: "$t( المقدّمون {{numbers}}, arabicToEasternArabic)",
        participants: "$t( المشاركون {{numbers}}, arabicToEasternArabic)",
        votingResults: "نتائج التصويت",
        attachments: "المرفقات",
        meetingType: "نوع الاجتماع",
        workspace: "مساحة العمل",
        date: "التاريخ",
        time: "الوقت",
        rejected: "مرفوض",
        download: "تنزيل الملخص",
        edit: "تعديل الملخص",
        waitingForApproval: "بانتظار الموافقة",
        downloadSignedSummary: "تحميل الملخص الموقع",
        waitingForSign: "بانتظار التوقيع",
        day: "يوم",
        day_one: "يوم",
        week: "أسبوع",
        dontSetTime: "عدم تحديد موعد",
        addMembers: "إضافة أعضاء",
        editMode: "وضع التعديل",
        save: "حفظ التغييرات",
        clickToEdit: "انقر فوق العناصر التي ترغب في تعديلها",
        uploadTitle: "توقيع ملخص الاجتماع",
        uploadText: "قم بتنزيل الملخص والتوقيع عليه وتحميل صورة ضوئية له هنا.",
        timeTitle: "تحديد موعد للموافقة",
        timeText: "حدد الموعد الذي سيتم قبول الملخص فيه",
        quorum: "اكتمال النصاب",
        notReached: "لم يكتمل النصاب",
        signedSummaries: "المحضر موقع",
        usersInvitedToApprove: "تمت دعوة المستخدمين للاعتماد",
        day_other: "أيام",
        addConclusion: "إضافة قسم",
        editConclusion: "التعديل على الخاتمة ",
        conclusionUpdated: "تحديث نتائج التصويت الملخص",
        conclusion: "الخاتمة ",
        editNote: "تعديل الملاحظة",
      },
      liveParticipants: {
        noParticipants: "لا يوجد مشاركون",
        participants: "المشاركون",
        guests: "الضيوف",
        declined: "تم الرفض",
        online: "المستخدمون المتصلون",
      },
      settings: {
        basic: "الأساسي",
        users: "المستخدمون",
        companyData: "بيانات الشركة",
        basicDescription: " معلومات عن شركتك",
        usersList: "قائمة المستخدمين",
        usersDescription: " يمكنك إضافة أو حذف أو تعديل المستخدمين من شركتك",
        rolesAndPermissions: "الأدوار والاهتمامات",
        setPermissions: "تعيين أذونات الأدوار في تطبيقك.",
      },
      errors: {
        somethingWentWrong: "حدث خطأ ما",
        errorCreatingTask: "خطأ في إنشاء المهمة",
        filesUploadError: "خطأ في تحميل الملفات",
        subsectionPostError: "خطأ في إنشاء القسم الفرعي",
      },
      createTemplateForm: {
        addTemplate: "إضافة قالب",
        editTemplate: "تعديل القالب",
        titleRequired: "العنوان مطلوب",
        nameTooLong: "الاسم طويل جدًا. الحد الأقصى 50 حرفًا",
        agendaRequired: "المطلوب جدول الأعمال",
        categoryRequired: "الفئة مطلوبة",
        descriptionTooLong: "الوصف طويل جدًا. الحد الأقصى 200 حرف",
        enterMeetingTitle: "أدخل عنوان الاجتماع",
        description: "وصف القالب (اختياري)",
        createTemplate: "إنشاء",
        updateTemplate: "تحديث",
        confirmDelete: "هل أنت متأكد أنك تريد حذف القالب؟",
        viewTemplate: "عرض القالب",
      },
      meetingList: {
        title: "عنوان الاجتماع",
        type: "النوع",
        status: "الحالة",
        workspace: "مساحة العمل",
        creator: "مستضاف بواسطة",
        startDate: "تاريخ ووقت الاجتماع",
      },
      departmentList: {
        lifeCycle: "دورة الحياة",
        totalMembersInWorkspace: "إجمالي الأعضاء في مساحة العمل",
        name: "اسم مساحة العمل",
        createdBy: "تم الإنشاء بواسطة",
        totalMembers: "إجمالي الأعضاء",
        creationDate: "تاريخ الإنشاء",
        actions: "الإجراءات",
      },
      adminUser: {
        userDetails: "تفاصيل المستخدم",
        seeDetails: "عرض التفاصيل",
        company: "الشركة",
        status: "الحالة",
        trailEnds: "انتهاء الفترة التجريبية",
        actions: "الإجراءات",
        memberOfAdmins: "أنت حالياً عضو في {{count}}",
        basicInfo: "المعلومات الأساسية",
        userId: "معرف المستخدم",
        name: "الاسم",
        email: "البريد الإلكتروني",
        isAdmin: "مشرف",
        companyInfo: "معلومات الشركة",
        packageName: "الباقة",
        subscription: "الاشتراك",
        trial: "تجريبي",
        daysRemaining: "الأيام المتبقية",
        timestamps: "الطوابع الزمنية",
        createdAt: "تاريخ الإنشاء",
      },
    },
  },
};

//eslint-disable-next-line
const compareObjects = (
  enObj: {
    [x: string]: any;
  },
  arObj: {
    [x: string]: any;
  },
  path = ""
) => {
  for (const key of Object.keys(enObj)) {
    if (!(key in arObj)) {
      console.log(`${path}${key}: ${enObj[key]}`);
      continue;
    }

    if (typeof enObj[key] === "object") {
      //eslint-disable-next-line
      compareObjects(enObj[key], arObj[key], `${path}${key}.`);
    }
  }
};

//uncomment this if you want to see missing translations
// compareObjects(resources.en, resources.ar);

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "ar",
    debug: false,
    lng: "ar",
    supportedLngs: ["ar", "en"],
    // fallbackLng: "pl",
    // lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
    },
  });

if (i18n && i18n.services && i18n.services.formatter) {
  i18n.services.formatter.add(
    "arabicToEasternArabic",
    (value, lng, options) => {
      return value.replace(
        options.numbers || options.count || 0,
        convertToEasternArabic(options.numbers || options.count || 0)
      );
    }
  );
}

export default i18n;
